import {Component, OnInit, OnDestroy} from "@angular/core";

import {MatDialog, MAT_DIALOG_DATA} from "@angular/material";
import {ActivatedRoute, Router} from "@angular/router";
import {AddProjectDialogComponent} from "../../../shared/add-project-dialog/add-project-dialog.component";
import {
  AdminService,
  CommonService,
  ProjectService,
  AlertService,
  ProfileService,
  FileService,
  LeadService,
} from "../../../_services/";

import {supervisorsEmailList} from "../../../_helper/global";

import {AngularFireStorage} from "@angular/fire/storage";
import * as firebase from "firebase/app"; // Typescript
// import firebase from 'firebase/app'; // JS
import "firebase/functions";

import {EditProjectDialogComponent} from "../edit-project-dialog/edit-project-dialog.component";

import {AddAppointmentDialogComponent} from "../../../shared/add-appointment-dialog/add-appointment-dialog.component";
import {AddReminderDialogComponent} from "../../../shared/add-reminder-dialog/add-reminder-dialog.component";
import {AddNoteDialogComponent} from "../../../shared/add-note-dialog/add-note-dialog.component";
import {ProjectMapFilesDialogComponent} from "../../../shared/project-map-files-dialog/project-map-files-dialog.component";

import {ScheduleWalkThroughDialogComponent} from "./../schedule-walk-through-dialog/schedule-walk-through-dialog.component";
import {RequestDeliveryDialogComponent} from "../request-delivery-dialog/request-delivery-dialog.component";
import {SendToProductionDialogComponent} from "../send-to-production-dialog/send-to-production-dialog.component";

import {environment} from "../../../../environments/environment";
import {ToastrService} from "ngx-toastr";
import {FormBuilder, FormGroup} from "@angular/forms";

import * as moment from "moment";
import * as XLSX from "xlsx";

import * as fileSaver from "file-saver";
import {HttpResponse} from "@angular/common/http";
import {map, finalize} from "rxjs/operators";
import {Observable, Subscription} from "rxjs";
import {AngularFireFunctions} from "@angular/fire/functions";

// Algolia
import algoliasearch from "algoliasearch";
import {EditReminderDialogComponent} from "src/app/shared/edit-reminder-dialog/edit-reminder-dialog.component";

const client = algoliasearch(
  environment.algolia.appId,
  environment.algolia.adminAPIKey
);
const index = client.initIndex("projects");
const index2 = client.initIndex("contacts");

@Component({
  selector: "app-project-detail",
  templateUrl: "./project-detail.component.html",
  styleUrls: ["./project-detail.component.scss"],
  providers: [AngularFireFunctions],
})
export class ProjectDetailComponent implements OnInit {
  items = [];
  excelArray: any[] = [];
  fileName = "Projects.xlsx";
  errMsg = "";
  projectStepFieldList: any[] = [];
  newFieldList: any[];
  projectStepList: any[];
  successMsg = "";
  projectSearchAreaStatus: Boolean;
  showField: String;
  ref: any;
  m: Number = 0;
  downloadURL: Observable<string>;
  appointmentList: any[] = [];
  reminderList: any[] = [];
  noteList: any[] = [];
  loadNext: Boolean = false;
  categoryList = [];
  neededDocuments: any[] = [];
  isSupervisor: Boolean;
  step2PreconditionId: String[] = [];
  // step2FulfillingProjectIds:String[] = [];
  // step2FieldIds:any[]=[];
  fileList: any[] = [];
  showSchedule;
  technicalDesignerList: any[] = [];
  sendToProductionStatus: Boolean = false;
  contactData: any[] = [];
  showProject: Boolean;
  projectId: String;
  contactId: String;
  otherProjects: any[] = [];
  curTab: String = "";
  initialRender = true;
  childProjects: any[] = [];
  step7ScratchCondition: Boolean;
  step7ExistingError: String;
  technicalDesignerEmail = "";
  private subscription: Subscription;
  private subscription2: Subscription;
  private subscription3: Subscription;
  private subscription4: Subscription;
  private subscription5: Subscription;
  private subscription6: Subscription;
  private subscription7: Subscription;
  private subscription8: Subscription;
  private subscription9: Subscription;
  private subscription10: Subscription;
  private subscription11: Subscription;
  private subscription12: Subscription;
  // private subscription13 : Subscription;
  // private subscription14 : Subscription;
  private subscription15: Subscription;
  private subscription16: Subscription;
  private subscription17: Subscription;
  private subscription18: Subscription;
  private subscription19: Subscription;
  notSendEmail: String[] = [
    "AJNF8kai80awhOqdyriE",
    "3xPNW91yXwtfzPGwYbKQ",
    "sidc1JE2dl5ULVDN9oU5",
    "F3T9MchJCsVzqqdVvtKA",
    "Hl1fu22xaQCXJYM9kOuP",
    "dTuXL5JW8iSrZCGdDQXJ",
    "keJkG4i9ZRGhc23pgIiy",
    "tgcqF7VCNZPTwRmlvzdW",
    "BSlQmkony0t3PkqRPiOv",
    "1O9VYmrtoJIoxTZRVXAz",
    "KizAgomsXDIRtTwSnuVI",
    "IeETmE82P0ADVxMZjhg6",
    "sxVy1Aj0AmObwXkXT6NC",
    "ksvqcM3caUhybNM9Z6PJ",
    "pQKV2Kz5lkQFomjiAB7M",
    "qyMJbAWjGXB9eYPxcT0v",
    "igaF8mbHPesUBMTgGlIk",
    "90vBMjb3ueK4kcja4CGD",
  ];
  public projectNotExists = false;
  fieldUpdate: any[] = [
    {
      field_id: "xRXVxF0c7u4CZFZsg2gO",
      update_obj: {retainer_agreement_added: "Yes"},
    },
    {field_id: "Zy3PlGuCMUSGheaoI8sp", update_obj: {floor_plan_added: "Yes"}},
    {field_id: "e0RYXmb3zPR6Abb92MPm", update_obj: {estimate_added: "Yes"}},
    {field_id: "Uv29YgfyUxe8LP0nfb0m", update_obj: {step1_design_added: "Yes"}},
    {field_id: "OcBHaOfjEwGb20s5Y5ZM", update_obj: {step1_kps_added: "Yes"}},
    {field_id: "a1PxDbztOzyX5TkGkHW1", update_obj: {design_added: "Yes"}},

    // {"field_id":"pFTqLhQyPGx4xhhsmRqU","update_obj":{"original_walk_through_added":"Yes"}},
    {
      field_id: "pyHdp66THa5G04GAquMr",
      update_obj: {desired_production_week_added: "Yes"},
    },
    {
      field_id: "tASShhH47wpRYFkkQbPr",
      update_obj: {updated_design_added: "Yes"},
    },
    {field_id: "16jq0ASz1FsSP2HbRSBb", update_obj: {size_added: "Yes"}},
    {field_id: "2xRks4oV4X2XHFTstXtO"},
    {field_id: "8Mwe89gcvBYNuOuurhVe", update_obj: {complexity_added: "Yes"}},
    {field_id: "99KrwVmq0xNOnrYs3xoE", update_obj: {brand_added: "Yes"}},
    {
      field_id: "Aa0mO4IwJOBMq6t46EpL",
      update_obj: {amount_of_cabinets_added: "Yes"},
    },
    {
      field_id: "hdTkfyCa5Vc6N0KouQM0",
      update_obj: {walk_through_checklist_added: "Yes"},
    },
    {
      field_id: "S9sBI93pFQryXyV6a5xw",
      update_obj: {walk_through_measurements_added: "Yes"},
    },
    {field_id: "Wv8Acm3vQspa2zP4ireH", update_obj: {site_photos_added: "Yes"}},
    {
      field_id: "EZqW8QL9dwgImazd7oDp",
      update_obj: {appliances_form_added: "Yes"},
    },
    {
      field_id: "xmBq40fr0zlZ00pxTJvA",
      update_obj: {style_selection_form_added: "Yes"},
    },
    {field_id: "1cPSWuR2lklh6WrDV45H", update_obj: {kps_added: "Yes"}},
    {
      field_id: "Qe60jcBLSkYneVSJHlVO",
      update_obj: {installation_required_added: "Yes"},
    },
    {
      field_id: "MYk4iyBUC7ov2ulmO82u",
      update_obj: {appliances_purchased_added: "Yes"},
    },
    {field_id: "0SfMD1NzS7wADpK8CnMl", update_obj: {paid_invoice_added: "Yes"}},
    {
      field_id: "BKIVzGG3c7QTZQf0gUUD",
      update_obj: {paid_invoice_installation_added: ""},
    },
    {
      field_id: "436OtEW0yVyPBL9hQOdo",
      update_obj: {paid_invoice_countertop_added: "Yes"},
    },
    {
      field_id: "3xPNW91yXwtfzPGwYbKQ",
      update_obj: {purchase_agreement_cabinetry_added: "Yes"},
    },
    {
      field_id: "sDrj14gZbe9hCicAgZ2C",
      update_obj: {mechanical_plan_added: "Yes"},
    },
    {
      field_id: "90vBMjb3ueK4kcja4CGD",
      update_obj: {step5_review_request_date_created: new Date().getTime()},
    },
    {
      field_id: "dTuXL5JW8iSrZCGdDQXJ",
      update_obj: {
        installation_plans_added: "Yes",
        installation_plans_approved: "No",
      },
    },
    {
      field_id: "keJkG4i9ZRGhc23pgIiy",
      update_obj: {
        order_confirmation_added: "Yes",
        order_confirmation_approved: "No",
      },
    },
    {
      field_id: "tgcqF7VCNZPTwRmlvzdW",
      update_obj: {perspectives_added: "Yes", perspectives_approved: "No"},
    },
    {
      field_id: "BSlQmkony0t3PkqRPiOv",
      update_obj: {
        appliance_spec_package_added: "Yes",
        appliance_spec_package_approved: "No",
      },
    },
    {
      field_id: "03OG6ByYwQbbKxDMtJMl",
      update_obj: {step7_5_review_request_date_initiated: new Date().getTime()},
    },
    {
      field_id: "1O9VYmrtoJIoxTZRVXAz",
      update_obj: {
        delivery_photos_added: "Yes",
        delivery_photos_confirmation_date_initiated: null,
      },
    },
    {
      field_id: "KizAgomsXDIRtTwSnuVI",
      update_obj: {
        delivery_confirmation_added: "Yes",
        delivery_photos_confirmation_date_initiated: null,
      },
    },
    {
      field_id: "ftEJXgXxLJSx7TURKR1X",
      update_obj: {
        service_parts_form_added: "Yes",
        step9_review_request_date_initiated: null,
      },
    },
    {
      field_id: "DZhmDe7EHwrewjqKwjaR",
      update_obj: {sign_off_photo_form_date_initiated: null},
    },
    {
      field_id: "7rzReBw64drX4imfGGDn",
      update_obj: {sign_off_photo_form_date_initiated: null},
    },
  ];
  multiFileFieldArr = [
    "pFTqLhQyPGx4xhhsmRqU",
    "Wv8Acm3vQspa2zP4ireH",
    "keJkG4i9ZRGhc23pgIiy",
    "1O9VYmrtoJIoxTZRVXAz",
    "KizAgomsXDIRtTwSnuVI",
    "IeETmE82P0ADVxMZjhg6",
    "igaF8mbHPesUBMTgGlIk",
    "ksvqcM3caUhybNM9Z6PJ",
    "pQKV2Kz5lkQFomjiAB7M",
    "qyMJbAWjGXB9eYPxcT0v",
    "sxVy1Aj0AmObwXkXT6NC",
    "DZhmDe7EHwrewjqKwjaR",
  ];
  template1 = [
    {id: "0R916HDqzvjEKmBFpqfH", name: "pm1_cc_authorization"},
    {id: "mRTdrFw6udbN7vzWtRlu", name: "pm1_proof_of_payment"},
    {id: "xRXVxF0c7u4CZFZsg2gO", name: "pm1_retainer_agreement"},
    {id: "Zy3PlGuCMUSGheaoI8sp", name: "pm2_floor_plan"},
    {id: "a1PxDbztOzyX5TkGkHW1", name: "pm2_design"},
    {id: "MHBKi8WjUMgv6gQBzK06", name: "pm4_purchase_agrmnt_countertop"},
    {id: "vu3lIrztm7uznhNrJUMu", name: "pm4_purchase_agrmnt_installation"},
    {id: "wUoMfmN9qckgXBOrCPGX", name: "pm4_purchase_agreement_appliances"},
    {id: "90vBMjb3ueK4kcja4CGD", name: "pm5_signed_final_design"},
    {id: "03OG6ByYwQbbKxDMtJMl", name: "pm7_5_paid_invoice"},
    {id: "7rzReBw64drX4imfGGDn", name: "pm10_sign_off_form_file"},
    {id: "DZhmDe7EHwrewjqKwjaR", name: "pm10_sign_off_photo_form"},
    {id: "kRU6y4vmTZOVTMHusHbO", name: "pm11_project_signed_off"},
  ];
  showShareForm = false;
  searchContacts: any[] = [];
  searchContactIds: String[] = [];
  shareForm: FormGroup;
  shareRecord: any;
  constructor(
    public dialog: MatDialog,
    private afStorage: AngularFireStorage,
    private _common: CommonService,
    private _admin: AdminService,
    private _project: ProjectService,
    private _alert: AlertService,
    private _profile: ProfileService,
    private _toastr: ToastrService,
    private _file: FileService,
    public _lead: LeadService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private fns: AngularFireFunctions
  ) {}

  ngOnInit() {
    this.isSupervisor = supervisorsEmailList.includes(
      localStorage.getItem("rs-email")
    )
      ? true
      : false;
    if (firebase.apps.length < 2) {
      const app = firebase.initializeApp(environment.firebaseConfig);
      if (window.location.host.includes("localhost")) {
        app.functions().useFunctionsEmulator("http://localhost:5000");
      }
    }

    this.route.paramMap.subscribe((params) => {
      this.projectNotExists = false;
      this.projectId = params.get("id");
      this._profile.updateTab(this.projectId);
      this.getProjectMapStepField();
      this.getProjectById();

      this.getChildProjects();
    });
    // this.getStepDocCategoryList();
    this.getTechnicalDesigner();
    this.shareForm = this.fb.group({
      keyword: ["", []],
      recipient_contact_id: ["", []],
      message: ["", []],
    });
  }

  getTechnicalDesigner() {
    this.subscription = this._project.getTechnicalDesigner().subscribe(
      (res) => {
        if (res.length > 0) {
          this.technicalDesignerList = res.map((item) =>
            item.payload.doc.data()
          );
        }
      },
      (err) => {
        this.errMsg =
          err.error && err.error.message
            ? err.error.message
            : "Something went wrong!";
      }
    );
  }
  toggleShareForm() {
    this.showShareForm = !this.showShareForm;
  }

  // Search Algolia...
  searchAlgolia(form) {
    this.searchContactIds = [];
    this.searchContacts = [];
    const requestOptions = {
      headers: {},
    };
    // Search Contacts...
    index2.search(form.value.keyword, requestOptions).then(({hits}) => {
      if (form.value.keyword != "") {
        this.searchContacts = [];
        hits.forEach((item: any) => {
          if (item.contact_type_id == "staff") {
            this.searchContacts.push({
              owner_first_name: item["owner_first_name"],
              owner_last_name: item["owner_last_name"],
              first_name: item["first_name"],
              last_name: item["last_name"],
              mobile_phone: item["mobile_phone"],
              email: item["email"],
              objectID: item["objectID"],
            });
          }
        });
      }
    });
  }

  onFormSubmit(): void {
    this.errMsg = "";
    this.successMsg = "";
    if (this.shareForm.invalid) {
      return;
    }
    let form = this.shareForm.value;
    const obj = {
      sender_contact_id: localStorage.getItem("contactId"),
      recipient_contact_id: form.recipient_contact_id,
      record_id: this.projectId,
      comment: form.message,
      record_type: "project",
    };
    if (window.location.host.includes("localhost")) {
      this.fns.functions.useFunctionsEmulator("http://localhost:5000");
    }
    this._common.showLoader(true);
    const recordShare = this.fns.httpsCallable("record_share");
    recordShare(obj).subscribe(
      (result) => {
        this._common.showLoader(false);
        if (result.outcome === "success") {
          this.shareForm.reset();
          this.successMsg = result.message;
          this.showShareForm = false;
        } else {
          this.errMsg = result.message;
        }
      },
      (err) => {
        this.errMsg =
          err && err.message ? err.message : "Something went wrong!";
      }
    );
  }

  getProjectById() {
    this.items = [];
    this._common.showLoader(true);
    this.subscription2 = this._project
      .getProjectById({projectId: this.projectId})
      .subscribe(
        (res: any) => {
          this.projectNotExists = false;
          this.items = res;
          if (
            res &&
            res[0] &&
            res[0].payload &&
            res[0].payload.exists == false
          ) {
            this._common.showLoader(false);
            this.projectNotExists = true;
            return;
          }
          this.contactId = this.items[0].payload.data().contact_id;
          // TEMP CODE FOR PROJECT IMPORT CORRECTION...
          if (
            this.items.length > 0 &&
            this.items[0].payload.data() &&
            this.items[0].payload.data()["rs2"] &&
            this.items[0].payload.data()["rs2"].field_technical_designer &&
            // && this.items[0].payload.data()['rs2'].field_technical_designer.length>0
            this.items[0].payload.data()["rs2"].field_technical_designer.und &&
            this.items[0].payload.data()["rs2"].field_technical_designer
              .und[0] &&
            this.items[0].payload.data()["rs2"].field_technical_designer.und[0]
              .value
          ) {
            // Code to check if technical designer is not updated for this project
            this._project
              .getProjectTechincalDesigner(
                this.items[0].payload.data().id,
                "06qKtGZKZdkQ6Ngeq0oO"
              )
              .subscribe(
                (res) => {
                  if (res.length === 0) {
                    const nodeObj = {
                      uid: this.items[0].payload.data()["owner_user_id"],
                      created: this.items[0].payload.data()["date_created"],
                      changed: this.items[0].payload.data()["date_updated"],
                      author_contact_id:
                        this.items[0].payload.data()["author_contact_id"],
                      owner_user_id:
                        this.items[0].payload.data()["owner_user_id"],
                      owner_contact_id:
                        this.items[0].payload.data()["rs2"]["uid"],
                      project_id: this.items[0].payload.data().id,
                      step_id: "LhIlUTywq2V8mVEyd4eW",
                      step_number: 3,
                      field_id: "06qKtGZKZdkQ6Ngeq0oO",
                      contact_id: this.items[0].payload.data()["contact_id"],
                      value:
                        this.items[0].payload.data()["rs2"]
                          .field_technical_designer.und[0].value,
                      type: "select",
                    };
                    // Code to add techincal designer...
                    this._project
                      .addTechnicalDesigner(nodeObj)
                      .then((res) => {
                        // console.log(res,'Value updated for techincal designer');
                      })
                      .catch((err) => {
                        this.errMsg =
                          err.error && err.error.message
                            ? err.error.message
                            : "Error occured while updating technical designer!";
                      });
                  }
                },
                (err) => {
                  console.log(err, "error");
                }
              );
          }
          // CODE FOR CORRECTING DRIVE FILE IMPORT
          // get all records from files collection by project id...
          /*  this._project.getProjectMapFileDownloadLink(this.projectId).subscribe(res=>{
          const filesArr = res.map(item => item.payload.doc.data());
          if(res.length>0){
            // Check for Retainer Agreement file 
            const file1Index = filesArr.findIndex((file:any)=>file.project_map_field_id === "xRXVxF0c7u4CZFZsg2gO");
            // Check for Floor Plan
            const file2Index = filesArr.findIndex((file:any)=>file.project_map_field_id === "Zy3PlGuCMUSGheaoI8sp");
            // Check for Design
            const file3Index = filesArr.findIndex((file:any)=>file.project_map_field_id === "a1PxDbztOzyX5TkGkHW1");
            // Check for Site Photos
            const file4Index = filesArr.findIndex((file:any)=>file.project_map_field_id === "Wv8Acm3vQspa2zP4ireH");
            // Check for Walk through checklist file
            const file5Index = filesArr.findIndex((file:any)=>file.project_map_field_id === "hdTkfyCa5Vc6N0KouQM0");
            // Check for Walk-through Measurements File
            const file6Index = filesArr.findIndex((file:any)=>file.project_map_field_id === "S9sBI93pFQryXyV6a5xw");
            // Check for Updated Design File
            const file7Index = filesArr.findIndex((file:any)=>file.project_map_field_id === "tASShhH47wpRYFkkQbPr");
            // Check for Appliances Form File
            const file8Index = filesArr.findIndex((file:any)=>file.project_map_field_id === "EZqW8QL9dwgImazd7oDp");
            // Check for Style Selection Form File
            const file9Index = filesArr.findIndex((file:any)=>file.project_map_field_id === "xmBq40fr0zlZ00pxTJvA");

            



          }

        },err =>{
          this._toastr.error(`Error occured while fetching project files!`,"",{ timeOut: 4000 });  
        })*/

          if (this.items[0].payload.exists === false) {
            this._toastr.error(`Project does not exists!`, "", {timeOut: 4000});
            this._common.navigate("project-list");
            return;
          }
          // Load contact data
          const contactId = this.items[0].payload.data().contact_id;
          this.subscription3 = this._project
            .getProjectContactDetail(contactId)
            .subscribe((res) => {
              this.contactData = res.map((item) => item.payload.doc.data());
              // Code to Check is project will be visible or not.
              const showroomId = this.items[0].payload.data().showroom_id;

              if (
                localStorage.getItem("uid") == "9052" &&
                (showroomId == "131917" || showroomId == "131910")
              ) {
                // For Ohad
                this.showProject = true;
              } else if (
                localStorage.getItem("uid") == "13420" &&
                (showroomId == "131917" || showroomId == "131910")
              ) {
                // For Brian
                this.showProject = true;
              } else if (
                localStorage.getItem("uid") == "9428" &&
                (showroomId == "131917" || showroomId == "131910")
              ) {
                // For Leah
                this.showProject = true;
              } else if (
                localStorage.getItem("uid") == "9324" ||
                localStorage.getItem("uid") == "JI4HufuwBFRUZWU02NYVJ2wpJUf1" ||
                localStorage.getItem("uid") == "14071" ||
                localStorage.getItem("uid") == "9624" ||
                localStorage.getItem("uid") == "12917" ||
                localStorage.getItem("uid") == "13928" ||
                localStorage.getItem("uid") == "13831" ||
                localStorage.getItem("uid") == "9613" ||
                localStorage.getItem("uid") == "13575" ||
                localStorage.getItem("uid") == "1" ||
                localStorage.getItem("uid") == "12464" ||
                localStorage.getItem("uid") == "14109"
              ) {
                // For Jia/Amy
                this.showProject = true;
              } else if (
                localStorage.getItem("uid") == "14564" &&
                (this.contactId === "422690465" ||
                  this.contactId === "422690607" ||
                  this.contactId === "422638964")
              ) {
                this.showProject = true;
              } else if (
                localStorage.getItem("uid") == "r2dSyCJfjhd5vuW4QMvqGYKY7483" &&
                this.contactId === "422680998"
              ) {
                this.showProject = true;
              } else {
                if (
                  this.items[0].payload.data().owner_contact_id ===
                  localStorage.getItem("contactId")
                ) {
                  this.showProject = true;
                } else {
                  this.showProject = false;
                }
              }

              this.subscription5 = this._project
                .getOtherProjects(this.items[0].payload.data().contact_id)
                .subscribe(
                  (otherProject) => {
                    this.otherProjects = otherProject
                      .map((item) => item.payload.doc.data())
                      .filter(
                        (innterItem) => innterItem["id"] !== this.projectId
                      );
                  },
                  (err) => {
                    this._toastr.error(
                      `Found error while fetching similar projects!`,
                      "",
                      {timeOut: 4000}
                    );
                  }
                );
              this.items[0].projectStepFieldList = [];
              this._common.showLoader(false);

              this.subscription6 = this._project
                .getAllFileList(this.projectId)
                .subscribe(
                  (res) => {
                    this.fileList = res;
                    // iterate item for binding project list with dynamics steps and its value
                    // for(let j=0; j<this.items[0].length; j++){
                    let contactIndex = this.contactData.findIndex(
                      (item) =>
                        item.id === this.items[0].payload.data().contact_id
                    );
                    this.items[0].contactData =
                      contactIndex === -1
                        ? {showroom: []}
                        : this.contactData[contactIndex];

                    // Update contact_first_name & contact_last_name in projects collection if contact name mismaches between contacts & project collection
                    if (
                      this.items[0].contactData.first_name !==
                        this.items[0].payload.data().contact_first_name ||
                      this.items[0].contactData.last_name !==
                        this.items[0].payload.data().contact_last_name
                    ) {
                      this._admin
                        .editProject(
                          {
                            contact_first_name:
                              this.items[0].contactData.first_name,
                            contact_last_name:
                              this.items[0].contactData.last_name,
                          },
                          this.projectId
                        )
                        .then(
                          (res) => {},
                          (err) => {
                            this._toastr.error(`Something went wrong!`, "", {
                              timeOut: 4000,
                            });
                          }
                        );
                    }
                    this.items[0].projectStepList = this.projectStepList;
                    // iterate field listing to update if the value/file for this is added
                    this.newFieldList = [];
                    for (let k = 0; k < this.projectStepFieldList.length; k++) {
                      this.newFieldList.push([]);

                      for (
                        let l = 0;
                        l < this.projectStepFieldList[k].length;
                        l++
                      ) {
                        this.newFieldList[k].push([]);
                        let fieldObj = {
                          field_id:
                            this.projectStepFieldList[k][l].payload.doc.id,
                          field_type:
                            this.projectStepFieldList[k][l].payload.doc.data()
                              .field_type,
                          select_list: this.projectStepFieldList[k][
                            l
                          ].payload.doc.data().select_list
                            ? this.projectStepFieldList[k][l].payload.doc.data()
                                .select_list
                            : [],
                          project_map_step_id:
                            this.projectStepFieldList[k][l].payload.doc.data()
                              .project_map_step_id,
                          name: this.projectStepFieldList[k][
                            l
                          ].payload.doc.data().name,
                        };
                        for (let m = 0; m < this.items[1][0].length; m++) {
                          if (
                            this.projectStepFieldList[k][l].payload.doc.id ===
                            this.items[1][0][m].payload.doc.data()
                              .project_map_field_id
                          ) {
                            // field_id
                            // && this.items[0][j].payload.doc.id===this.items[1][j][m].payload.doc.data().project_id
                            // Store technical desigenr email for mail sending at Step 5 approval
                            if (
                              this.projectStepFieldList[k][l].payload.doc.id ===
                              "06qKtGZKZdkQ6Ngeq0oO"
                            ) {
                              this.technicalDesignerEmail =
                                this.items[1][0][m].payload.doc.data().value;
                            }
                            let field_type =
                              this.items[1][0][m].payload.doc.data().type;
                            let field_value =
                              this.items[1][0][m].payload.doc.data().value; // field_value
                            let node_id = this.items[1][0][m].payload.doc.id;
                            let fb_storage_download_url =
                              this.items[1][0][m].payload.doc.data()
                                .fb_storage_download_url;

                            fieldObj["addedData"] = {
                              field_type,
                              field_value,
                              node_id,
                              fb_storage_download_url,
                              project_id:
                                this.items[1][0][m].payload.doc.data()
                                  .project_id,
                            };
                          }
                        }
                        //check file data from files collection and set in the final array...
                        let fileIndex = this.fileList.findIndex(
                          (item) =>
                            item.payload.doc.data().project_map_field_id ===
                              this.projectStepFieldList[k][l].payload.doc.id &&
                            item.payload.doc.data().project_id ===
                              this.items[0].payload.data().id
                        );
                        if (fileIndex > -1) {
                          fieldObj["addedData"] = {
                            field_type: "file",
                            project_id:
                              this.fileList[fileIndex].payload.doc.data()
                                .project_id,
                            node_id:
                              this.fileList[fileIndex].payload.doc.data().id,
                            gd_file_id:
                              this.fileList[fileIndex].payload.doc.data()
                                .gd_file_id,
                            gd_folder_id:
                              this.fileList[fileIndex].payload.doc.data()
                                .gd_folder_id,
                          };
                        }
                        this.newFieldList[k][l].push(fieldObj);
                      }

                      if (k + 1 == this.projectStepFieldList.length) {
                        this.items[0].projectStepFieldList = this.newFieldList;
                      }
                    }
                  },
                  (err) => {
                    this.errMsg =
                      err.error && err.error.message
                        ? err.error.message
                        : "Something went wrong!";
                  }
                );

              // Load appointments, reminders, notes...
              this.subscription7 = this._lead
                .getAppointmentList({projectId: this.projectId})
                .subscribe(
                  (result) => {
                    // this._common.showLoader(false);
                    this.appointmentList = result;
                    // fetch reminder list...
                    this.subscription8 = this._lead
                      .getReminderList({projectId: this.projectId})
                      .subscribe(
                        (result2) => {
                          // this._common.showLoader(false);
                          this.reminderList = result2;
                          // fetch notes list...
                          this.subscription9 = this._lead
                            .getNotesList({contactId: this.contactId})
                            .subscribe(
                              (result3) => {
                                this.noteList = result3;

                                let obj = {
                                  appointmentList: {},
                                  reminderList: {},
                                  notesList: {},
                                };
                                obj.appointmentList = this.appointmentList;
                                obj.reminderList = this.reminderList;
                                obj.notesList = this.noteList;
                                this.items[0].boxData = obj;

                                this._common.showLoader(false);
                              },
                              (err) => {
                                this._common.showLoader(false);
                                this._alert.error(
                                  err.error && err.error.message
                                    ? err.error.message
                                    : "Something went wrong!"
                                );
                              }
                            );
                        },
                        (err) => {
                          this._common.showLoader(false);
                          this._alert.error(
                            err.error && err.error.message
                              ? err.error.message
                              : "Something went wrong!"
                          );
                        }
                      );
                  },
                  (err) => {
                    this._common.showLoader(false);
                    this._alert.error(
                      err.error && err.error.message
                        ? err.error.message
                        : "Something went wrong!"
                    );
                  }
                );
            });
        },
        (error) => {
          this._common.showLoader(false);
          this._alert.error(
            error.error && error.error.message
              ? error.error.message
              : "Something went wrong!"
          );
        }
      );
  }

  getChildProjects() {
    //   fetch all child projects
    this._project.getChildProjects(this.projectId).then((res: any) => {
      this.childProjects = res.map((item) => item.payload.doc.data());
    });
  }

  openAddProjectDialog(client_id) {
    this.dialog.open(AddProjectDialogComponent, {
      width: "auto",
      data: {
        client_id: client_id,
        modalSource: "project",
      },
    });
  }

  openEditProjectDialog(id) {
    let dialogRef = this.dialog.open(EditProjectDialogComponent, {
      width: "auto",
      data: {
        id: id,
      },
    });

    dialogRef.afterClosed().subscribe((response) => {
      // this.getUserList(localStorage.getItem('uid'))
    });
  }

  // Open Edit Reminder Dialog
  openEditReminderDilaog(id) {
    this.successMsg = "";
    this.errMsg = "";
    this.dialog.open(EditReminderDialogComponent, {
      width: "auto",
      data: {
        reminder_id: id,
      },
    });
  }

  // Delete project
  deleteProject(id) {
    this._common.showLoader(true);
    // delete project data over algolia

    this._admin
      .deleteProject(id)
      .then((res) => {
        index
          .deleteObjects([id])
          .then(({objectIDs}) => {
            this._common.showLoader(false);
            this.router.navigate(["/project-list"]);
            this.successMsg = "Project deleted successfully!";
          })
          .catch((err) => {
            this.errMsg = "Something went wrong while updating over Algolia";
          });
      })
      .catch((err) => {
        this._common.showLoader(false);
        this.errMsg = err.error.message
          ? err.error.message
          : "Something went wrong!";
      });
  }

  // Get project map field
  getProjectMapStepField() {
    this.subscription8 = this._project.getProjectMapStep().subscribe(
      (res) => {
        this.projectStepList = res[0];
        // code to fetch the project map step category...
        this.subscription9 = this._lead.getCategoriesList().subscribe(
          (categoryList) => {
            // code to fetch the project map step category file...
            this.subscription10 = this._lead.getCategoryFileList().subscribe(
              (fileList) => {
                // remove previously fetched data with below for loop...
                for (let k = 0; k < this.projectStepList.length; k++) {
                  this.projectStepList[k].docs = [];
                }
                for (let i = 0; i < categoryList.length; i++) {
                  const index = this.projectStepList.findIndex(
                    (item) =>
                      item.payload.doc.id ===
                      categoryList[i].payload.doc.data()["project_map_step_id"]
                  );
                  if (index === -1) {
                  } else {
                    // fetch files for current category
                    let files = [];
                    for (let j = 0; j < fileList.length; j++) {
                      if (
                        fileList[j].payload.doc.data()[
                          "project_map_step_category_id"
                        ] === categoryList[i].payload.doc.id
                      ) {
                        files.push(fileList[j].payload.doc.data());
                      }
                    }
                    let obj = {
                      id: categoryList[i].payload.doc.data()["id"],
                      date_created:
                        categoryList[i].payload.doc.data()["date_created"],
                      name: categoryList[i].payload.doc.data()["name"],
                      project_map_step_id:
                        categoryList[i].payload.doc.data()[
                          "project_map_step_id"
                        ],
                      files: files,
                    };

                    this.projectStepList[index].docs.push(obj);
                  }
                }
              },
              (error) => {
                this._alert.error(
                  error.error && error.error.message
                    ? error.error.message
                    : "Something went wrong!"
                );
              }
            );
          },
          (error) => {
            this._alert.error(
              error.error && error.error.message
                ? error.error.message
                : "Something went wrong!"
            );
          }
        );

        this.projectStepFieldList = res[1];
      },
      (err) => {
        this.errMsg =
          err.error && err.error.message
            ? err.error.message
            : "Something went wrong!";
      }
    );
  }

  // Upload file
  async uploadFile(
    event,
    step_id,
    node_id,
    contact_id,
    step_name,
    step_number,
    project_name,
    project_map_step_field_name,
    project_map_step_field_id,
    contact_first_name,
    contact_last_name,
    owner_contact_id,
    owner_user_id,
    accouting_ref
  ) {
    this.curTab = step_id;
    this._common.showLoader(true);
    const file = (event.target as HTMLInputElement).files;
    const project_id = event.target.id.split(",")[1];
    const field_id = event.target.id.split(",")[0];

    const uid = localStorage.getItem("uid");
    try {
      for (let i = 0; i < file.length; i++) {
        const fileName = event.target.files[i].name;
        this.ref = this.afStorage.ref(
          `projects/${project_id}/${event.target.files[i].name}`
        );
        const task = await this.afStorage.upload(
          `projects/${project_id}/${event.target.files[i].name}`,
          event.target.files[i]
        );
        const file_type = file[0].type;

        // this.uploadImageAsPromise(randomId, fileName, event.target.files[i], project_id ).then(res=>{
        // }).catch(err=>{
        // })
        // task.snapshotChanges().pipe(
        //   finalize(() => {
        let tempStepId =
          field_id === "Hl1fu22xaQCXJYM9kOuP"
            ? "evwdciVNp0SQ6Qwxd790"
            : step_id;
        this.downloadURL = this.ref.getDownloadURL();
        // this.downloadURL.subscribe(async (url) => {
        const url = await this.getDownloadURlPromise(this.downloadURL);
        if (url) {
          let data = {
            download_url: url,
            project_id: project_id,
            step_id: tempStepId,
            field_id: field_id,
            fbs_path: `projects/${project_id}/${event.target.files[i].name}`,
            type: "file",
            node_id: node_id,
            uid: localStorage.getItem("uid"),
            fileName,
            contact_id,
            step_name,
            project_map_step_field_name,
            file_type,
            owner_contact_id,
            owner_user_id,
          };
          var functions = firebase.functions();
          let createFile = firebase.functions().httpsCallable("create_file");
          // createFile(data).then((result:any) => {
          const result: any = await createFile(data);
          // this.getAllFileList();
          // this.getProjectById();
          // Update projects collection
          if (i + 1 === file.length) {
            // Update Project
            const UploadIndex = this.fieldUpdate.findIndex(
              (item) => item.field_id === project_map_step_field_id
            );
            if (UploadIndex > -1) {
              if (
                project_map_step_field_id == "0SfMD1NzS7wADpK8CnMl" ||
                project_map_step_field_id == "3xPNW91yXwtfzPGwYbKQ"
              ) {
                this.fieldUpdate[
                  UploadIndex
                ].update_obj.step4_review_email_timestamp =
                  Date.now() + Math.random();
              }
              this._admin
                .editProject(
                  this.fieldUpdate[UploadIndex].update_obj,
                  project_id
                )
                .then(
                  (res) => {},
                  (err) => {
                    this._toastr.error(`Something went wrong!`, "", {
                      timeOut: 4000,
                    });
                  }
                );
            }

            // Create drive file link:
            let driveLink = "";
            if (this.multiFileFieldArr.includes(project_map_step_field_id)) {
              driveLink =
                "https://drive.google.com/drive/u/1/folders/" +
                result.data.gd_folder_id;
            } else {
              driveLink =
                "https://drive.google.com/file/d/" +
                result.data.gd_file_id +
                "/view";
            }
            this._common.showLoader(false);
            if (this.notSendEmail.indexOf(project_map_step_field_id) === -1) {
              const curIndex = this.template1.findIndex(
                (item) => item.id === project_map_step_field_id
              );
              if (curIndex !== -1) {
                // Code to get the desiger detail....
                this.subscription11 = this._lead
                  .getContactDetail(owner_contact_id)
                  .subscribe(
                    (designer) => {
                      this.subscription16 = this._project
                        .getEmailRecipient(this.template1[curIndex].name)
                        .subscribe(
                          (emailRes) => {
                            const emails = emailRes.docs.map((doc) =>
                              doc.data()
                            );
                            if (emails.length > 0) {
                              this.subscription17 = this._project
                                .getSystemMode()
                                .subscribe(
                                  (system) => {
                                    const systemData = system.map((item) =>
                                      item.payload.doc.data()
                                    );
                                    const mode: any = systemData.filter(
                                      (item) => item.hasOwnProperty("mode")
                                    );
                                    const baseUrlObj = systemData.filter(
                                      (item) => item.hasOwnProperty("base_url")
                                    );
                                    const designerEmail =
                                      designer.payload.data()["email"]
                                        ? designer.payload.data()["email"]
                                        : "";
                                    let cc =
                                      mode[0].mode === "Live"
                                        ? emails[0]["live_receipients"] +
                                          "," +
                                          designerEmail
                                        : emails[0]["dev_receipients"] +
                                          "," +
                                          emails[0]["dev_designers"];
                                    // if(this.template1[curIndex].name === "pm5_signed_final_design"){ // Add technical designer mail to cc for Signed Final Design
                                    //   if(cc){
                                    //     if(this.technicalDesignerEmail){
                                    //       cc = cc+','+this.technicalDesignerEmail;
                                    //     }
                                    //   }
                                    // }

                                    //Code to send email
                                    const accoutingRef =
                                      accouting_ref && accouting_ref != ""
                                        ? `REF# ${accouting_ref} - `
                                        : "";
                                    const contact_name =
                                      contact_first_name &&
                                      contact_first_name != ""
                                        ? `${contact_first_name} ${contact_last_name} -`
                                        : "";
                                    let mailBody;
                                    // if(project_map_step_field_id === "90vBMjb3ueK4kcja4CGD"){ // If block to send mail for Step 5 Signed Final Design
                                    //   mailBody = {
                                    //     to : 'rs@leichtnewyork.com',
                                    //     subject :`${accoutingRef} ${contact_name} ${project_name} - Step ${step_number} - ${project_map_step_field_name} - Review Request`,
                                    //     body : `Review requested for: ${project_map_step_field_name}<br/>Step: ${step_number}<br/>Name: ${contact_first_name} ${contact_last_name}<br/> Designer: ${designer.payload.data()['first_name']} ${designer.payload.data()['last_name']} <br/>Reference #: ${accouting_ref}<br/>  Signed Final Design: ${driveLink}<br/>Account: ${baseUrlObj[0]['base_url']}contact/${contact_id} <br/>Project: ${baseUrlObj[0]['base_url']}project/${project_id}<br/><br/>-<br/>Automated email sent via RS`,
                                    //     cc: cc
                                    //   }
                                    // } else {
                                    mailBody = {
                                      to: "rs@leichtnewyork.com",
                                      subject: `${accoutingRef} ${contact_name} ${project_name} - Step ${step_number} - ${project_map_step_field_name}`,
                                      body: `Name: ${contact_first_name} ${contact_last_name}<br/> Designer: ${
                                        designer.payload.data()["first_name"]
                                      } ${
                                        designer.payload.data()["last_name"]
                                      } <br/> Download: ${driveLink}<br/>Account: ${
                                        baseUrlObj[0]["base_url"]
                                      }contact/${contact_id} <br/>Project: ${
                                        baseUrlObj[0]["base_url"]
                                      }project/${project_id}<br/><br/>-<br/>Automated email sent via RS`,
                                      cc: cc,
                                    };
                                    // }

                                    this._project.initEmail(mailBody).subscribe(
                                      (res) => {
                                        if (res) {
                                          this._common.showLoader(false);
                                          this._toastr.success(
                                            `File uploaded successfully, Mail sent`,
                                            "",
                                            {timeOut: 4000}
                                          );
                                        }
                                      },
                                      (err) => {
                                        this._common.showLoader(false);
                                        this._toastr.success(
                                          `File uploaded successfully, Mail not sent`,
                                          "",
                                          {timeOut: 4000}
                                        );
                                      }
                                    );
                                  },
                                  (err) => {
                                    this._common.showLoader(false);
                                    this._toastr.success(
                                      `File uploaded successfully, Mail not sent`,
                                      "",
                                      {timeOut: 4000}
                                    );
                                  }
                                );
                            } else {
                              this._common.showLoader(false);
                              this._toastr.error(
                                `Email configuration not found`,
                                "",
                                {timeOut: 4000}
                              );
                            }
                          },
                          (err) => {
                            this._common.showLoader(false);
                            this._toastr.success(
                              `File uploaded successfully, Mail not sent`,
                              "",
                              {timeOut: 4000}
                            );
                          }
                        );
                    },
                    (err) => {
                      this._common.showLoader(false);
                      this._toastr.error(
                        `${
                          err && err.error && err.error.message
                            ? err.error.message
                            : "Something went wrong!"
                        }`,
                        "",
                        {timeOut: 4000}
                      );
                    }
                  );
              } else {
                this._common.showLoader(false);
                this._toastr.success("File uploaded successfully!", "", {
                  timeOut: 4000,
                });
              }
            } else {
              this._common.showLoader(false);
              this._toastr.success("File uploaded successfully!", "", {
                timeOut: 4000,
              });
            }
          }
          // },err=>{
          //   this._common.showLoader(false);
          //   this._toastr.error(`${ err && err.error  && err.error.message? err.error.message :  'Something went wrong!'}`,"",{ timeOut: 4000 });

          // });
        }

        //   })
        // ).subscribe(url => {})
      }
    } catch (e) {
      this._common.showLoader(false);
      this._toastr.error(`${"Something went wrong while uploading file"}`, "", {
        timeOut: 4000,
      });
    }
  }

  getDownloadURlPromise(downloadUrl) {
    return new Promise((resolve, reject) => {
      downloadUrl.subscribe(
        (url) => {
          resolve(url);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  // Create Project Map Node...
  createProjectMapNode(
    project_id,
    step_id,
    project_map_step_field_id,
    project_num,
    node_id,
    contact_id,
    step_number,
    project_map_step_field_name,
    type
  ) {
    this.curTab = step_id;
    this._common.showLoader(true);
    let inputVal = (
      document.getElementById(
        `${project_map_step_field_id}0`
      ) as HTMLInputElement
    ).value;

    if (node_id) {
      this._project.updateNode(node_id, {value: inputVal}).then(
        (res) => {
          const UploadIndex = this.fieldUpdate.findIndex(
            (item) => item.field_id === project_map_step_field_id
          );
          if (UploadIndex > -1) {
            let obj =
              project_map_step_field_id === "2xRks4oV4X2XHFTstXtO"
                ? {accounting_ref: inputVal}
                : this.fieldUpdate[UploadIndex].update_obj;
            this._admin.editProject(obj, project_id).then(
              (res) => {},
              (err) => {
                this._toastr.success(`Something went wrong!`, "", {
                  timeOut: 4000,
                });
              }
            );
          }
          this._common.showLoader(false);
          this._toastr.success("Node successfully updated", "", {
            timeOut: 4000,
          });
        },
        (err) => {
          this._common.showLoader(false);
          this._toastr.error("Something went wrong", "", {timeOut: 4000});
        }
      );
    } else {
      let data = {
        value: inputVal,
        contact_id: contact_id,
        project_map_field_id: project_map_step_field_id,
        project_map_step_number: step_number,
        project_map_step_id: step_id,
        project_id: project_id,
        uid: localStorage.getItem("uid"),
        type,
      };

      var functions = firebase.functions();
      let createNode = firebase
        .functions()
        .httpsCallable("create_project_map_node");
      createNode(data)
        .then((result: any) => {
          const UploadIndex = this.fieldUpdate.findIndex(
            (item) => item.field_id === project_map_step_field_id
          );
          if (UploadIndex > -1) {
            let obj =
              project_map_step_field_id === "2xRks4oV4X2XHFTstXtO"
                ? {accounting_ref: inputVal}
                : this.fieldUpdate[UploadIndex].update_obj;
            this._admin.editProject(obj, project_id).then(
              (res) => {},
              (err) => {
                this._toastr.error(
                  `Something went wrong while updating projects!`,
                  "",
                  {timeOut: 4000}
                );
              }
            );
          }
          this._common.showLoader(false);
          this._toastr.success(result.data.message, "", {timeOut: 4000});
        })
        .catch((err) => {
          this._common.showLoader(false);
          this._toastr.error(
            `${
              err && err.error && err.error.message
                ? err.error.message
                : "Something went wrong!"
            }`,
            "",
            {timeOut: 4000}
          );
        });
    }
  }

  selectContact(item) {
    let fullName = item.first_name + " " + item.last_name;
    this.shareForm.patchValue({
      keyword: fullName,
      recipient_contact_id: item.objectID,
    });

    this.searchContacts = [];
  }

  showSaveBtn(field_type, field_id) {
    if (field_type === "string" || field_type === "select") {
      this.showField = field_id;
    }
  }

  download(url) {
    // this._file.getData(url)
    // .subscribe(
    //   imgData =>{ console.log(imgData);},
    //   err => console.log(err)
    // );
    this._file.downloadFile(url).subscribe((response) => {
      let blob: any = new Blob([response.blob()], {
        type: "text/json; charset=utf-8",
      });
      fileSaver.saveAs(
        blob,
        `download.${url.split("?")[0].split(".").reverse()[0]}`
      );
    }),
      (error) => console.log("Error downloading the file"),
      () => console.info("File downloaded successfully");
  }

  // Open add appointment dialog
  openAddAppointmentDialog(id, contact_id) {
    this.dialog.open(AddAppointmentDialogComponent, {
      width: "auto",
      data: {
        project_id: id,
        contact_id: contact_id,
        category: "project",
      },
    });
  }

  // Add open reminder dialog
  openAddReminderDilaog(id, contact_id, owner_contact_id) {
    this.dialog.open(AddReminderDialogComponent, {
      width: "auto",
      data: {
        project_id: id,
        contact_id: contact_id,
        owner_contact_id: owner_contact_id,
        category: "project",
      },
    });
  }

  // Add note dialog
  openAddNoteDilaog(id, contact_id) {
    this.dialog.open(AddNoteDialogComponent, {
      width: "auto",
      data: {
        project_id: id,
        contact_id: contact_id,
        category: "project",
      },
    });
  }

  // OpenStepWalkThroughDialog
  openStepWalkThroughDialog(
    project_name,
    contact_first_name,
    contact_last_name,
    project_address,
    contact_id,
    project_id,
    owner_contact_id
  ) {
    this.dialog.open(ScheduleWalkThroughDialogComponent, {
      width: "auto",
      data: {
        project_name,
        contact_first_name,
        contact_last_name,
        project_address,
        contact_id,
        project_id,
        owner_contact_id,
      },
    });
  }

  // Open Request Delivery Modal
  openRequestDeliveryModal(
    project_id,
    project_data,
    step_number,
    step_id,
    owner_contact_id
  ) {
    this.curTab = `${step_id}`;
    this.dialog.open(RequestDeliveryDialogComponent, {
      width: "auto",
      data: {
        project_id,
        accounting_ref: project_data.accounting_ref,
        contact_first_name: project_data.contact_first_name,
        contact_last_name: project_data.contact_last_name,
        project_name: project_data.name,
        step_number,
        owner_contact_id,
      },
    });
  }

  // Open SendToProductionModal
  openSendToProductionModal(project_id, step_id) {
    this.curTab = `${step_id}`;
    this.dialog.open(SendToProductionDialogComponent, {
      width: "auto",
      data: {
        project_id,
      },
    });
  }

  // Request techinal designer
  requestTechicalDesigner(project_id, project_data, step_number, step_id) {
    this.curTab = step_id;
    this._common.showLoader(true);
    this._admin
      .editProject(
        {
          technical_designer_requested: "Yes",
          step3_review_request_date_initiated: Date.now(),
        },
        project_id
      )
      .then(
        (res) => {
          this.subscription12 = this._lead
            .getContactDetail(project_data.owner_contact_id)
            .subscribe(
              (designer) => {
                // this.subscription13 =
                this._project
                  .getProjectMapNodePromise(project_id)
                  .then((nodeList: any) => {
                    const nodes = nodeList.map((item) =>
                      item.payload.doc.data()
                    );
                    this._project
                      .getProjectMapDriveLink(project_id)
                      .then((fileList: any) => {
                        const files = fileList.map((item) =>
                          item.payload.doc.data()
                        );
                        const requestedProductionWeekIndex = nodes.findIndex(
                          (item) =>
                            item["project_map_field_id"] ===
                            "ffOuAulZqHN3avAzbfi5"
                        );
                        const sizeIndex = nodes.findIndex(
                          (item) =>
                            item["project_map_field_id"] ===
                            "16jq0ASz1FsSP2HbRSBb"
                        );
                        const complexityIndex = nodes.findIndex(
                          (item) =>
                            item["project_map_field_id"] ===
                            "8Mwe89gcvBYNuOuurhVe"
                        );
                        const cabinetsIndex = nodes.findIndex(
                          (item) =>
                            item["project_map_field_id"] ===
                            "Aa0mO4IwJOBMq6t46EpL"
                        );
                        const brandIndex = nodes.findIndex(
                          (item) =>
                            item["project_map_field_id"] ===
                            "99KrwVmq0xNOnrYs3xoE"
                        );
                        // Create drive file link:
                        const appliancesIndex = files.findIndex(
                          (item) =>
                            item["project_map_field_id"] ===
                            "EZqW8QL9dwgImazd7oDp"
                        );
                        let AppliancesFormDriveLink =
                          this.multiFileFieldArr.includes(
                            "EZqW8QL9dwgImazd7oDp"
                          )
                            ? "https://drive.google.com/drive/u/1/folders/" +
                              files[appliancesIndex]["gd_folder_id"]
                            : "https://drive.google.com/file/d/" +
                              files[appliancesIndex]["gd_file_id"] +
                              "/view";

                        const photosIndex = files.findIndex(
                          (item) =>
                            item["project_map_field_id"] ===
                            "Wv8Acm3vQspa2zP4ireH"
                        );
                        let SitePhotosDriveLink =
                          this.multiFileFieldArr.includes(
                            "Wv8Acm3vQspa2zP4ireH"
                          )
                            ? "https://drive.google.com/drive/u/1/folders/" +
                              files[photosIndex]["gd_folder_id"]
                            : "https://drive.google.com/file/d/" +
                              files[photosIndex]["gd_file_id"] +
                              "/view";

                        const SsIndex = files.findIndex(
                          (item) =>
                            item["project_map_field_id"] ===
                            "xmBq40fr0zlZ00pxTJvA"
                        );
                        let SsFormDriveLink = this.multiFileFieldArr.includes(
                          "xmBq40fr0zlZ00pxTJvA"
                        )
                          ? "https://drive.google.com/drive/u/1/folders/" +
                            files[SsIndex]["gd_folder_id"]
                          : "https://drive.google.com/file/d/" +
                            files[SsIndex]["gd_file_id"] +
                            "/view";

                        const walkChecklistIndex = files.findIndex(
                          (item) =>
                            item["project_map_field_id"] ===
                            "hdTkfyCa5Vc6N0KouQM0"
                        );
                        let WChecklistDriveLink =
                          this.multiFileFieldArr.includes(
                            "hdTkfyCa5Vc6N0KouQM0"
                          )
                            ? "https://drive.google.com/drive/u/1/folders/" +
                              files[walkChecklistIndex]["gd_folder_id"]
                            : "https://drive.google.com/file/d/" +
                              files[walkChecklistIndex]["gd_file_id"] +
                              "/view";

                        const measurementIndex = files.findIndex(
                          (item) =>
                            item["project_map_field_id"] ===
                            "S9sBI93pFQryXyV6a5xw"
                        );
                        let measurementDriveLink =
                          this.multiFileFieldArr.includes(
                            "S9sBI93pFQryXyV6a5xw"
                          )
                            ? "https://drive.google.com/drive/u/1/folders/" +
                              files[measurementIndex]["gd_folder_id"]
                            : "https://drive.google.com/file/d/" +
                              files[measurementIndex]["gd_file_id"] +
                              "/view";

                        const kpsIndex = files.findIndex(
                          (item) =>
                            item["project_map_field_id"] ===
                            "1cPSWuR2lklh6WrDV45H"
                        );
                        let kpsDriveLink = this.multiFileFieldArr.includes(
                          "1cPSWuR2lklh6WrDV45H"
                        )
                          ? "https://drive.google.com/drive/u/1/folders/" +
                            files[kpsIndex]["gd_folder_id"]
                          : "https://drive.google.com/file/d/" +
                            files[kpsIndex]["gd_file_id"] +
                            "/view";

                        const updatedDesignIndex = files.findIndex(
                          (item) =>
                            item["project_map_field_id"] ===
                            "tASShhH47wpRYFkkQbPr"
                        );
                        let updatedDesignDriveLink =
                          this.multiFileFieldArr.includes(
                            "tASShhH47wpRYFkkQbPr"
                          )
                            ? "https://drive.google.com/drive/u/1/folders/" +
                              files[updatedDesignIndex]["gd_folder_id"]
                            : "https://drive.google.com/file/d/" +
                              files[updatedDesignIndex]["gd_file_id"] +
                              "/view";

                        this.subscription17 = this._project
                          .getEmailRecipient("pm3_request_technical_designer")
                          .subscribe(
                            (emailRes) => {
                              const emails = emailRes.docs.map((doc) =>
                                doc.data()
                              );
                              if (emails.length > 0) {
                                this.subscription = this._project
                                  .getSystemMode()
                                  .subscribe(
                                    (system) => {
                                      const systemData = system.map((item) =>
                                        item.payload.doc.data()
                                      );
                                      const mode: any = systemData.filter(
                                        (item) => item.hasOwnProperty("mode")
                                      );
                                      const baseUrlObj = systemData.filter(
                                        (item) =>
                                          item.hasOwnProperty("base_url")
                                      );
                                      const designerEmail =
                                        designer.payload.data()["email"]
                                          ? designer.payload.data()["email"]
                                          : "";
                                      const cc =
                                        mode[0].mode === "Live"
                                          ? emails[0]["live_receipients"] +
                                            "," +
                                            designerEmail
                                          : emails[0]["dev_receipients"] +
                                            "," +
                                            emails[0]["dev_designers"];
                                      //Code to send email
                                      let brandValue =
                                        brandIndex > 0
                                          ? "- " +
                                            nodes[brandIndex]["value"] +
                                            " "
                                          : "";

                                      const mailBody = {
                                        to: "rs@leichtnewyork.com", //
                                        subject: `Ref#: ${project_data.accounting_ref} - ${project_data.contact_first_name} ${project_data.contact_last_name} - [${project_data.name}] Step ${step_number} ${brandValue} - TD Request`,
                                        body: `Name: ${
                                          project_data.contact_first_name
                                        } ${
                                          project_data.contact_last_name
                                        }<br/><br/>Designer: ${
                                          designer.payload.data()["first_name"]
                                        } ${
                                          designer.payload.data()["last_name"]
                                        } <br/><br/> Reference #: ${
                                          project_data.accounting_ref
                                        } <br/><br/> Status: ${
                                          project_data.status_name
                                        }<br/><br/>Requested Production Week: ${
                                          nodes[requestedProductionWeekIndex][
                                            "value"
                                          ]
                                        }<br/><br/> Size: ${
                                          nodes[sizeIndex]["value"]
                                        }<br/><br/>Complexity:${
                                          nodes[complexityIndex]["value"]
                                        }<br/><br/> Amount of Cabinets: ${
                                          nodes[cabinetsIndex]["value"]
                                        } <br/><br/> Appliances Form:${AppliancesFormDriveLink} <br/><br/>Site Photos: ${SitePhotosDriveLink}<br/><br/>Style Selection Form: ${SsFormDriveLink}<br/><br/>Walk Through Checklist: ${WChecklistDriveLink}<br/><br/>Walk Through Measurements: ${measurementDriveLink}<br/><br/>KPS File: ${kpsDriveLink}<br/><br/>Updated Design: ${updatedDesignDriveLink}<br/><br/>Project:${
                                          baseUrlObj[0]["base_url"]
                                        }project/${project_id} <br/><br/>Account: ${
                                          baseUrlObj[0]["base_url"]
                                        }contact/${
                                          project_data.contact_id
                                        }<br/><br/>-<br/>Automated email sent via RS `,
                                        cc: cc,
                                      };

                                      this._project
                                        .initEmail(mailBody)
                                        .subscribe(
                                          (res) => {
                                            if (res) {
                                              this._common.showLoader(false);
                                              this._toastr.success(
                                                `Request sent successfully!`,
                                                "",
                                                {timeOut: 4000}
                                              );
                                            }
                                          },
                                          (err) => {
                                            this._common.showLoader(false);
                                            this._toastr.success(
                                              `Request sent successfully! Mail not sent`,
                                              "",
                                              {timeOut: 4000}
                                            );
                                          }
                                        );
                                    },
                                    (err) => {
                                      this._common.showLoader(false);
                                      this._toastr.error(
                                        `${
                                          err && err.error && err.error.message
                                            ? err.error.message
                                            : "Something went wrong!"
                                        }`,
                                        "",
                                        {timeOut: 4000}
                                      );
                                    }
                                  );
                              } else {
                                this._common.showLoader(false);
                                this._toastr.error(
                                  `Email configuration not found!`,
                                  "",
                                  {timeOut: 4000}
                                );
                              }
                            },
                            (err) => {
                              this._common.showLoader(false);
                              this._toastr.error(
                                `${
                                  err && err.error && err.error.message
                                    ? err.error.message
                                    : "Something went wrong!"
                                }`,
                                "",
                                {timeOut: 4000}
                              );
                            }
                          );
                      })
                      .catch((err) => {
                        this._common.showLoader(false);
                        this._toastr.error(
                          `${
                            err && err.error && err.error.message
                              ? err.error.message
                              : "Something went wrong!"
                          }`,
                          "",
                          {timeOut: 4000}
                        );
                      });
                  })
                  .catch((err) => {
                    this._common.showLoader(false);
                    this._toastr.error(
                      `${
                        err && err.error && err.error.message
                          ? err.error.message
                          : "Something went wrong!"
                      }`,
                      "",
                      {timeOut: 4000}
                    );
                  });
              },
              (err) => {
                this._common.showLoader(false);
                this._toastr.error(
                  `${
                    err && err.error && err.error.message
                      ? err.error.message
                      : "Something went wrong!"
                  }`,
                  "",
                  {timeOut: 4000}
                );
              }
            );
        },
        (err) => {
          this._toastr.error(`Something went wrong!`, "", {timeOut: 4000});
        }
      );
  }

  // Submit information review...
  submitInformationReview(step_number, project_id, project_data, step_id) {
    this.curTab = step_id;
    const status = document.getElementById(
      `${step_number}-${project_id}-status`
    )["value"];
    const text = document.getElementById(`${step_number}-${project_id}-text`)[
      "value"
    ];

    if (!status) {
      this._toastr.error(
        `Select Approve or Decline to submit Information Review`,
        "",
        {timeOut: 4000}
      );
      return false;
    }
    this._common.showLoader(true);
    let obj;
    switch (step_number) {
      case 2:
        obj = {
          step2_review_request_state: status,
          step2_review_request_comment: text,
        };
        break;
      case 3:
        obj = {
          step3_review_request_state: status,
          step3_review_request_comment: text,
        };
        break;
      case 4:
        obj = {
          step4_review_request_state: status,
          step4_review_request_comment: text,
        };
        break;
      case 5:
        obj = {
          step5_review_request_state: status,
          step5_review_request_comment: text,
        };
        break;
      case 6:
        obj = {
          step6_review_request_state: status,
          step6_review_request_comment: text,
        };
        break;
      case 7.5:
        obj = {
          step7_5_review_request_state: status,
          step7_5_review_request_comment: text,
        };
        break;
      case 9:
        obj = {
          step9_review_request_state: status,
          step9_review_request_comment: text,
        };
        break;
    }

    this._admin.editProject(obj, project_id).then(
      (res) => {
        this.subscription15 = this._lead
          .getContactDetail(project_data.owner_contact_id)
          .subscribe(
            (designer) => {
              if (status === "Approved") {
                let id = `pm${
                  step_number === 7.5 ? "7_5" : step_number
                }_review_approved`;

                this.subscription16 = this._project
                  .getEmailRecipient(id)
                  .subscribe(
                    (emailRes) => {
                      const emails = emailRes.docs.map((doc) => doc.data());
                      if (emails.length > 0) {
                        this.subscription17 = this._project
                          .getSystemMode()
                          .subscribe(
                            async (system) => {
                              const systemData = system.map((item) =>
                                item.payload.doc.data()
                              );
                              const mode: any = systemData.filter((item) =>
                                item.hasOwnProperty("mode")
                              );
                              const baseUrlObj = systemData.filter((item) =>
                                item.hasOwnProperty("base_url")
                              );
                              const designerEmail = designer.payload.data()[
                                "email"
                              ]
                                ? designer.payload.data()["email"]
                                : "";
                              let cc =
                                mode[0].mode === "Live"
                                  ? emails[0]["live_receipients"] +
                                    "," +
                                    designerEmail
                                  : emails[0]["dev_receipients"] +
                                    "," +
                                    emails[0]["dev_designers"];

                              if (
                                (step_number === 5 &&
                                  this.technicalDesignerEmail !== "") ||
                                (step_number === 9 &&
                                  this.technicalDesignerEmail !== "") ||
                                (step_number === 3 &&
                                  this.technicalDesignerEmail !== "")
                              ) {
                                if (cc == "") {
                                  cc = this.technicalDesignerEmail;
                                } else {
                                  cc = cc + "," + this.technicalDesignerEmail;
                                }
                              }

                              if (step_number === 6) {
                                const obj2 = {
                                  appliance_spec_package_approved: "Yes",
                                  perspectives_approved: "Yes",
                                  order_confirmation_approved: "Yes",
                                  installation_plans_approved: "Yes",
                                };
                                this._admin.editProject(obj2, project_id).then(
                                  (res) => {
                                    this._common.showLoader(false);
                                    this._toastr.success(
                                      "Request sent successfully!",
                                      "",
                                      {timeOut: 4000}
                                    );
                                  },
                                  (err) => {
                                    this._toastr.error(
                                      `Something went wrong while updating projects!`,
                                      "",
                                      {timeOut: 4000}
                                    );
                                  }
                                );
                              }
                              //Code to send email
                              const contactFirstName = localStorage.getItem(
                                "firstName"
                              )
                                ? localStorage.getItem("firstName")
                                : "";
                              const contactLastName = localStorage.getItem(
                                "lastName"
                              )
                                ? localStorage.getItem("lastName")
                                : "";
                              let html;
                              if (step_number != 9) {
                                let subject;
                                if (step_number === 3) {
                                  // If step number is 3
                                  // Fetch all the nodes value for current project...
                                  const nodesObj: any =
                                    await this._project.getProjectMapNodePromise(
                                      project_id
                                    );
                                  // this._project.getProjectMapNodePromise(project_id).then((nodeList:any)=>{
                                  const nodes = nodesObj.map((item) =>
                                    item.payload.doc.data()
                                  );
                                  const fileList: any =
                                    await this._project.getProjectMapDriveLink(
                                      project_id
                                    );
                                  const files = fileList.map((item) =>
                                    item.payload.doc.data()
                                  );
                                  const brandIndex = nodes.findIndex(
                                    (item) =>
                                      item["project_map_field_id"] ===
                                      "99KrwVmq0xNOnrYs3xoE"
                                  );
                                  let brandValue =
                                    brandIndex > 0
                                      ? "- " + nodes[brandIndex]["value"] + " "
                                      : "";
                                  const requestedProductionWeekIndex =
                                    nodes.findIndex(
                                      (item) =>
                                        item["project_map_field_id"] ===
                                        "ffOuAulZqHN3avAzbfi5"
                                    );
                                  const sizeIndex = nodes.findIndex(
                                    (item) =>
                                      item["project_map_field_id"] ===
                                      "16jq0ASz1FsSP2HbRSBb"
                                  );
                                  const complexityIndex = nodes.findIndex(
                                    (item) =>
                                      item["project_map_field_id"] ===
                                      "8Mwe89gcvBYNuOuurhVe"
                                  );
                                  const cabinetsIndex = nodes.findIndex(
                                    (item) =>
                                      item["project_map_field_id"] ===
                                      "Aa0mO4IwJOBMq6t46EpL"
                                  );
                                  const tdIndex = nodes.findIndex(
                                    (item) =>
                                      item["project_map_field_id"] ===
                                      "06qKtGZKZdkQ6Ngeq0oO"
                                  );
                                  let tdFirstName = "";
                                  let tdLastName = "";
                                  if (tdIndex > -1) {
                                    let tdObj =
                                      this.technicalDesignerList.filter(
                                        (item) =>
                                          item.email == nodes[tdIndex].value
                                      );
                                    tdFirstName =
                                      tdObj && tdObj.length > 0
                                        ? tdObj[0].first_name
                                        : "";
                                    tdLastName =
                                      tdObj && tdObj.length > 0
                                        ? tdObj[0].last_name
                                        : "";
                                  }

                                  // Create drive file link:
                                  const appliancesIndex = files.findIndex(
                                    (item) =>
                                      item["project_map_field_id"] ===
                                      "EZqW8QL9dwgImazd7oDp"
                                  );
                                  let AppliancesFormDriveLink =
                                    this.multiFileFieldArr.includes(
                                      "EZqW8QL9dwgImazd7oDp"
                                    )
                                      ? "https://drive.google.com/drive/u/1/folders/" +
                                        files[appliancesIndex]["gd_folder_id"]
                                      : "https://drive.google.com/file/d/" +
                                        files[appliancesIndex]["gd_file_id"] +
                                        "/view";

                                  const photosIndex = files.findIndex(
                                    (item) =>
                                      item["project_map_field_id"] ===
                                      "Wv8Acm3vQspa2zP4ireH"
                                  );
                                  let SitePhotosDriveLink =
                                    this.multiFileFieldArr.includes(
                                      "Wv8Acm3vQspa2zP4ireH"
                                    )
                                      ? "https://drive.google.com/drive/u/1/folders/" +
                                        files[photosIndex]["gd_folder_id"]
                                      : "https://drive.google.com/file/d/" +
                                        files[photosIndex]["gd_file_id"] +
                                        "/view";

                                  const SsIndex = files.findIndex(
                                    (item) =>
                                      item["project_map_field_id"] ===
                                      "xmBq40fr0zlZ00pxTJvA"
                                  );
                                  let SsFormDriveLink =
                                    this.multiFileFieldArr.includes(
                                      "xmBq40fr0zlZ00pxTJvA"
                                    )
                                      ? "https://drive.google.com/drive/u/1/folders/" +
                                        files[SsIndex]["gd_folder_id"]
                                      : "https://drive.google.com/file/d/" +
                                        files[SsIndex]["gd_file_id"] +
                                        "/view";

                                  const walkChecklistIndex = files.findIndex(
                                    (item) =>
                                      item["project_map_field_id"] ===
                                      "hdTkfyCa5Vc6N0KouQM0"
                                  );
                                  let WChecklistDriveLink =
                                    this.multiFileFieldArr.includes(
                                      "hdTkfyCa5Vc6N0KouQM0"
                                    )
                                      ? "https://drive.google.com/drive/u/1/folders/" +
                                        files[walkChecklistIndex][
                                          "gd_folder_id"
                                        ]
                                      : "https://drive.google.com/file/d/" +
                                        files[walkChecklistIndex][
                                          "gd_file_id"
                                        ] +
                                        "/view";

                                  const measurementIndex = files.findIndex(
                                    (item) =>
                                      item["project_map_field_id"] ===
                                      "S9sBI93pFQryXyV6a5xw"
                                  );
                                  let measurementDriveLink =
                                    this.multiFileFieldArr.includes(
                                      "S9sBI93pFQryXyV6a5xw"
                                    )
                                      ? "https://drive.google.com/drive/u/1/folders/" +
                                        files[measurementIndex]["gd_folder_id"]
                                      : "https://drive.google.com/file/d/" +
                                        files[measurementIndex]["gd_file_id"] +
                                        "/view";

                                  const kpsIndex = files.findIndex(
                                    (item) =>
                                      item["project_map_field_id"] ===
                                      "1cPSWuR2lklh6WrDV45H"
                                  );
                                  let kpsDriveLink =
                                    this.multiFileFieldArr.includes(
                                      "1cPSWuR2lklh6WrDV45H"
                                    )
                                      ? "https://drive.google.com/drive/u/1/folders/" +
                                        files[kpsIndex]["gd_folder_id"]
                                      : "https://drive.google.com/file/d/" +
                                        files[kpsIndex]["gd_file_id"] +
                                        "/view";

                                  const updatedDesignIndex = files.findIndex(
                                    (item) =>
                                      item["project_map_field_id"] ===
                                      "tASShhH47wpRYFkkQbPr"
                                  );
                                  let updatedDesignDriveLink =
                                    this.multiFileFieldArr.includes(
                                      "tASShhH47wpRYFkkQbPr"
                                    )
                                      ? "https://drive.google.com/drive/u/1/folders/" +
                                        files[updatedDesignIndex][
                                          "gd_folder_id"
                                        ]
                                      : "https://drive.google.com/file/d/" +
                                        files[updatedDesignIndex][
                                          "gd_file_id"
                                        ] +
                                        "/view";

                                  subject = `(Approved) Ref #: ${project_data.accounting_ref} - ${project_data.contact_first_name} ${project_data.contact_last_name} - ${project_data.name} - Step ${step_number} ${brandValue}`;

                                  html = `Approved by: ${contactFirstName} ${contactLastName}<br/><br/>Assigned Technical Designer: ${tdFirstName} ${tdLastName}<br/><br/>Comment: ${text}<br/><br/>Step: ${step_number} <br/><br/> Name: ${
                                    project_data.contact_first_name
                                  } ${
                                    project_data.contact_last_name
                                  } <br/><br/> Designer: ${
                                    designer.payload.data()["first_name"]
                                  } ${
                                    designer.payload.data()["last_name"]
                                  } <br/><br/>Reference #: ${
                                    project_data.accounting_ref
                                  }<br/><br/>Status: ${
                                    project_data.status_name
                                  }<br/><br/>Requested Production Week: ${
                                    nodes[requestedProductionWeekIndex]["value"]
                                  }<br/><br/>Size: ${
                                    nodes[sizeIndex]["value"]
                                  }<br/><br/>Complexity: ${
                                    nodes[complexityIndex]["value"]
                                  }<br/><br/>Amount of Cabinets: ${
                                    nodes[cabinetsIndex]["value"]
                                  }<br/><br/>Appliances Form:${AppliancesFormDriveLink} <br/><br/>Site Photos: ${SitePhotosDriveLink}<br/><br/>Style Selection Form: ${SsFormDriveLink}<br/><br/>Walk Through Checklist: ${WChecklistDriveLink}<br/><br/>Walk Through Measurements: ${measurementDriveLink}<br/><br/>KPS File: ${kpsDriveLink}<br/><br/>Updated Design: ${updatedDesignDriveLink}<br/><br/>Account: ${
                                    baseUrlObj[0]["base_url"]
                                  }contact/${
                                    project_data.contact_id
                                  }<br/><br/>Project: ${
                                    baseUrlObj[0]["base_url"]
                                  }project/${project_id} <br/><br/>-<br/>Automated email sent via RS `;
                                } else if (step_number === 5) {
                                  // If step number is 5
                                  const files = this.fileList.map((item) =>
                                    item.payload.doc.data()
                                  );

                                  const SFDIndex = files.findIndex(
                                    (item) =>
                                      item["project_map_field_id"] ===
                                      "90vBMjb3ueK4kcja4CGD"
                                  );
                                  let SFDDriveLink =
                                    "https://drive.google.com/file/d/" +
                                    files[SFDIndex]["gd_file_id"] +
                                    "/view";

                                  subject = `(Approved) Ref #: ${project_data.accounting_ref} - ${project_data.contact_first_name} ${project_data.contact_last_name} - ${project_data.name} - Step ${step_number} - Signed Final Design`;
                                  html = `Approved by: ${contactFirstName} ${contactLastName}<br/>Comment: ${text}<br/>Step: ${step_number} <br/> Name: ${
                                    project_data.contact_first_name
                                  } ${
                                    project_data.contact_last_name
                                  } <br/> Designer:  ${
                                    designer.payload.data()["first_name"]
                                  } ${
                                    designer.payload.data()["last_name"]
                                  } <br/>Reference #: ${
                                    project_data.accounting_ref
                                  }<br/>Signed Final Design: ${SFDDriveLink}<br/>Account: ${
                                    baseUrlObj[0]["base_url"]
                                  }contact/${
                                    project_data.contact_id
                                  }<br/>Project: ${
                                    baseUrlObj[0]["base_url"]
                                  }project/${project_id} <br/><br/>-<br/>Automated email sent via RS `;
                                } else if (step_number === 6) {
                                  // If step number is 6

                                  if (cc) {
                                    if (this.technicalDesignerEmail) {
                                      cc =
                                        cc + "," + this.technicalDesignerEmail;
                                    }
                                  } else {
                                    if (this.technicalDesignerEmail) {
                                      cc = this.technicalDesignerEmail;
                                    }
                                  }

                                  const files = this.fileList.map((item) =>
                                    item.payload.doc.data()
                                  );
                                  const IPIndex = files.findIndex(
                                    (item) =>
                                      item["project_map_field_id"] ===
                                      "dTuXL5JW8iSrZCGdDQXJ"
                                  );
                                  let IPDriveLink =
                                    IPIndex >= 0
                                      ? "https://drive.google.com/file/d/" +
                                        files[IPIndex]["gd_file_id"] +
                                        "/view"
                                      : "";
                                  const OCIndex = files.findIndex(
                                    (item) =>
                                      item["project_map_field_id"] ===
                                      "keJkG4i9ZRGhc23pgIiy"
                                  );
                                  let OCDriveLink =
                                    OCIndex >= 0
                                      ? "https://drive.google.com/drive/folders/" +
                                        files[OCIndex]["gd_folder_id"]
                                      : "";
                                  const PerspectiveIndex = files.findIndex(
                                    (item) =>
                                      item["project_map_field_id"] ===
                                      "tgcqF7VCNZPTwRmlvzdW"
                                  );
                                  let PDriveLink =
                                    PerspectiveIndex >= 0
                                      ? "https://drive.google.com/file/d/" +
                                        files[PerspectiveIndex]["gd_file_id"] +
                                        "/view"
                                      : "";
                                  const ASPIndex = files.findIndex(
                                    (item) =>
                                      item["project_map_field_id"] ===
                                      "BSlQmkony0t3PkqRPiOv"
                                  );
                                  let ASPDriveLink =
                                    ASPIndex >= 0
                                      ? "https://drive.google.com/file/d/" +
                                        files[ASPIndex]["gd_file_id"] +
                                        "/view"
                                      : "";

                                  subject = `(Approved) Ref #: ${project_data.accounting_ref} - ${project_data.contact_first_name} ${project_data.contact_last_name} - ${project_data.name} - Step ${step_number}`;
                                  html = `Approved by: ${contactFirstName} ${contactLastName}<br/>Comment: ${text}<br/>Step: ${step_number} <br/> Name: ${
                                    project_data.contact_first_name
                                  } ${
                                    project_data.contact_last_name
                                  } <br/> Designer:  ${
                                    designer.payload.data()["first_name"]
                                  } ${
                                    designer.payload.data()["last_name"]
                                  } <br/>Reference #: ${
                                    project_data.accounting_ref
                                  }<br/>Installation Plans: ${IPDriveLink}<br/>Order Confirmation: ${OCDriveLink}<br/>Perspectives: ${PDriveLink}<br/>Appliances Spec Sheet: ${ASPDriveLink}<br/>Account: ${
                                    baseUrlObj[0]["base_url"]
                                  }contact/${
                                    project_data.contact_id
                                  }<br/>Project: ${
                                    baseUrlObj[0]["base_url"]
                                  }project/${project_id} <br/><br/>-<br/>Automated email sent via RS `;
                                } else {
                                  subject = `(Approved) Ref #: ${project_data.accounting_ref} - ${project_data.contact_first_name} ${project_data.contact_last_name} - ${project_data.name} - Step ${step_number}`;
                                  html = `Approved by: ${contactFirstName} ${contactLastName}<br/>Comment: ${text}<br/>Step: ${step_number} <br/> Name: ${
                                    project_data.contact_first_name
                                  } ${
                                    project_data.contact_last_name
                                  } <br/> Designer:  ${
                                    designer.payload.data()["first_name"]
                                  } ${
                                    designer.payload.data()["last_name"]
                                  } <br/>Ref#: ${
                                    project_data.accounting_ref
                                  }<br/>Project: ${
                                    baseUrlObj[0]["base_url"]
                                  }project/${project_id} <br/>Account: ${
                                    baseUrlObj[0]["base_url"]
                                  }contact/${
                                    project_data.contact_id
                                  }<br/><br/>-<br/>Automated email sent via RS `;
                                }
                                const mailBody = {
                                  to: "rs@leichtnewyork.com",
                                  subject: subject,
                                  body: html,
                                  cc: cc,
                                };
                                this._project.initEmail(mailBody).subscribe(
                                  (res) => {
                                    if (res) {
                                      this._common.showLoader(false);
                                      this._toastr.success(
                                        `Request sent successfully!`,
                                        "",
                                        {timeOut: 4000}
                                      );
                                    }
                                  },
                                  (err) => {
                                    this._common.showLoader(false);
                                    this._toastr.success(
                                      `Request sent successfully! Mail not sent`,
                                      "",
                                      {timeOut: 4000}
                                    );
                                  }
                                );
                              } else {
                                // Get all files of a project for Step 9 approval mail...
                                this._project
                                  .getProjectMapFilesByStep(
                                    project_id,
                                    "zOiSVvp9oku6eedyZuet"
                                  )
                                  .subscribe(
                                    (resFiles) => {
                                      const arrFiles = resFiles.docs.map(
                                        (item) => item.data()
                                      );

                                      const servicePartIndex =
                                        arrFiles.findIndex(
                                          (item) =>
                                            item.project_map_field_id ===
                                            "ftEJXgXxLJSx7TURKR1X"
                                        );
                                      const servicePartFile =
                                        servicePartIndex > -1
                                          ? "https://drive.google.com/file/d/" +
                                            arrFiles[servicePartIndex]
                                              .gd_file_id +
                                            "/view"
                                          : "";
                                      const photo1Index = arrFiles.findIndex(
                                        (item) =>
                                          item.project_map_field_id ===
                                          "IeETmE82P0ADVxMZjhg6"
                                      );
                                      const photo1File =
                                        photo1Index > -1
                                          ? "https://drive.google.com/drive/u/1/folders/" +
                                            arrFiles[photo1Index].gd_folder_id
                                          : "";
                                      const photo2Index = arrFiles.findIndex(
                                        (item) =>
                                          item.project_map_field_id ===
                                          "sxVy1Aj0AmObwXkXT6NC"
                                      );
                                      const photo2File =
                                        photo2Index > -1
                                          ? "https://drive.google.com/drive/u/1/folders/" +
                                            arrFiles[photo2Index].gd_folder_id
                                          : "";
                                      const photo3Index = arrFiles.findIndex(
                                        (item) =>
                                          item.project_map_field_id ===
                                          "ksvqcM3caUhybNM9Z6PJ"
                                      );
                                      const photo3File =
                                        photo3Index > -1
                                          ? "https://drive.google.com/drive/u/1/folders/" +
                                            arrFiles[photo3Index].gd_folder_id
                                          : "";
                                      const photo4Index = arrFiles.findIndex(
                                        (item) =>
                                          item.project_map_field_id ===
                                          "pQKV2Kz5lkQFomjiAB7M"
                                      );
                                      const photo4File =
                                        photo4Index > -1
                                          ? "https://drive.google.com/drive/u/1/folders/" +
                                            arrFiles[photo4Index].gd_folder_id
                                          : "";
                                      const photo5Index = arrFiles.findIndex(
                                        (item) =>
                                          item.project_map_field_id ===
                                          "qyMJbAWjGXB9eYPxcT0v"
                                      );
                                      const photo5File =
                                        photo5Index > -1
                                          ? "https://drive.google.com/drive/u/1/folders/" +
                                            arrFiles[photo5Index].gd_folder_id
                                          : "";
                                      const photo6Index = arrFiles.findIndex(
                                        (item) =>
                                          item.project_map_field_id ===
                                          "igaF8mbHPesUBMTgGlIk"
                                      );
                                      const photo6File =
                                        photo6Index > -1
                                          ? "https://drive.google.com/drive/u/1/folders/" +
                                            arrFiles[photo6Index].gd_folder_id
                                          : "";

                                      html = `Approved by: ${contactFirstName} ${contactLastName}<br/>Comment: ${text}<br/>Step: ${step_number} <br/> Name: ${
                                        project_data.contact_first_name
                                      } ${
                                        project_data.contact_last_name
                                      } <br/> Designer:  ${
                                        designer.payload.data()["first_name"]
                                      } ${
                                        designer.payload.data()["last_name"]
                                      } <br/>Reference #: ${
                                        project_data.accounting_ref
                                      }<br/>Service Parts Form: ${servicePartFile} <br/>Installation Photos 1:${photo1File}<br/>Installation Photos 2:${photo2File}<br/>Installation Photos 3:${photo3File}<br/>Installation Photos 4:${photo4File} <br/>Installation Photos 5:${photo5File}<br/>Installation Photos 6:${photo6File} <br/><br/>Project: ${
                                        baseUrlObj[0]["base_url"]
                                      }project/${project_id} <br/>Account: ${
                                        baseUrlObj[0]["base_url"]
                                      }contact/${
                                        project_data.contact_id
                                      }<br/><br/>-<br/>Automated email sent via RS `;

                                      const mailBody = {
                                        to: "rs@leichtnewyork.com",
                                        subject: `(Approved) Ref #: ${project_data.accounting_ref} - ${project_data.contact_first_name} ${project_data.contact_last_name} - ${project_data.name} - Step ${step_number}`,
                                        body: html,
                                        cc: cc,
                                      };
                                      this._project
                                        .initEmail(mailBody)
                                        .subscribe(
                                          (res) => {
                                            if (res) {
                                              this._common.showLoader(false);
                                              this._toastr.success(
                                                `Request sent successfully!`,
                                                "",
                                                {timeOut: 4000}
                                              );
                                            }
                                          },
                                          (err) => {
                                            this._common.showLoader(false);
                                            this._toastr.success(
                                              `Request sent successfully! Mail not sent`,
                                              "",
                                              {timeOut: 4000}
                                            );
                                          }
                                        );
                                    },
                                    (err) => {
                                      this._toastr.error(
                                        `Something went wrong while fetching files!`,
                                        "",
                                        {timeOut: 4000}
                                      );
                                    }
                                  );
                              }
                            },
                            (err) => {
                              this._common.showLoader(false);
                              this._toastr.success(
                                "Request sent successfully!",
                                "",
                                {timeOut: 4000}
                              );
                            }
                          );
                      } else {
                        this._common.showLoader(false);
                        this._toastr.error(
                          "Email configuration not found!",
                          "",
                          {timeOut: 4000}
                        );
                      }
                    },
                    (err) => {
                      this._common.showLoader(false);
                      this._toastr.success("Request sent successfully!", "", {
                        timeOut: 4000,
                      });
                    }
                  );
              } else {
                // Declined
                let id = `pm${
                  step_number === 7.5 ? "7_5" : step_number
                }_review_declined`;
                this.subscription16 = this._project
                  .getEmailRecipient(id)
                  .subscribe(
                    (emailRes) => {
                      const emails = emailRes.docs.map((doc) => doc.data());
                      if (emails.length > 0) {
                        this.subscription17 = this._project
                          .getSystemMode()
                          .subscribe(
                            (system) => {
                              const systemData = system.map((item) =>
                                item.payload.doc.data()
                              );
                              const mode: any = systemData.filter((item) =>
                                item.hasOwnProperty("mode")
                              );
                              const baseUrlObj = systemData.filter((item) =>
                                item.hasOwnProperty("base_url")
                              );
                              const designerEmail = designer.payload.data()[
                                "email"
                              ]
                                ? designer.payload.data()["email"]
                                : "";
                              let cc =
                                mode[0].mode === "Live"
                                  ? emails[0]["live_receipients"] +
                                    "," +
                                    designerEmail
                                  : emails[0]["dev_receipients"] +
                                    "," +
                                    emails[0]["dev_designers"];

                              //Code to send email
                              const contactFirstName = localStorage.getItem(
                                "firstName"
                              )
                                ? localStorage.getItem("firstName")
                                : "";
                              const contactLastName = localStorage.getItem(
                                "lastName"
                              )
                                ? localStorage.getItem("lastName")
                                : "";
                              let subject;
                              let html;
                              if (step_number === 5) {
                                // If Step number is 5
                                if (cc) {
                                  if (this.technicalDesignerEmail) {
                                    cc = cc + "," + this.technicalDesignerEmail;
                                  }
                                } else {
                                  if (this.technicalDesignerEmail) {
                                    cc = this.technicalDesignerEmail;
                                  }
                                }

                                const files = this.fileList.map((item) =>
                                  item.payload.doc.data()
                                );
                                const SFDIndex = files.findIndex(
                                  (item) =>
                                    item["project_map_field_id"] ===
                                    "90vBMjb3ueK4kcja4CGD"
                                );
                                let SFDDriveLink =
                                  "https://drive.google.com/file/d/" +
                                  files[SFDIndex]["gd_file_id"] +
                                  "/view";

                                subject = `(Declined) Ref #: ${project_data.accounting_ref} - ${project_data.contact_first_name} ${project_data.contact_last_name} - ${project_data.name} - Step ${step_number} - Signed Final Design`;
                                html = `Declined by: ${contactFirstName} ${contactLastName}<br/>Comment: ${text}<br/>Step: ${step_number} <br/> Name: ${
                                  project_data.contact_first_name
                                } ${
                                  project_data.contact_last_name
                                } <br/> Designer:  ${
                                  designer.payload.data()["first_name"]
                                } ${
                                  designer.payload.data()["last_name"]
                                } <br/>Reference #: ${
                                  project_data.accounting_ref
                                }<br/>Signed Final Design: ${SFDDriveLink}<br/>Account: ${
                                  baseUrlObj[0]["base_url"]
                                }contact/${
                                  project_data.contact_id
                                }<br/>Project:${
                                  baseUrlObj[0]["base_url"]
                                }project/${project_id} <br/><br/>-<br/>Automated email sent via RS `;
                              } else if (step_number === 6) {
                                // If Step number is 6
                                if (cc) {
                                  if (this.technicalDesignerEmail) {
                                    cc = cc + "," + this.technicalDesignerEmail;
                                  }
                                } else {
                                  if (this.technicalDesignerEmail) {
                                    cc = this.technicalDesignerEmail;
                                  }
                                }
                                const files = this.fileList.map((item) =>
                                  item.payload.doc.data()
                                );
                                const IPIndex = files.findIndex(
                                  (item) =>
                                    item["project_map_field_id"] ===
                                    "dTuXL5JW8iSrZCGdDQXJ"
                                );
                                let IPDriveLink =
                                  IPIndex >= 0
                                    ? "https://drive.google.com/file/d/" +
                                      files[IPIndex]["gd_file_id"] +
                                      "/view"
                                    : "";
                                const OCIndex = files.findIndex(
                                  (item) =>
                                    item["project_map_field_id"] ===
                                    "keJkG4i9ZRGhc23pgIiy"
                                );
                                let OCDriveLink =
                                  OCIndex >= 0
                                    ? "https://drive.google.com/drive/folders/" +
                                      files[OCIndex]["gd_folder_id"]
                                    : "";
                                const PerspectiveIndex = files.findIndex(
                                  (item) =>
                                    item["project_map_field_id"] ===
                                    "tgcqF7VCNZPTwRmlvzdW"
                                );
                                let PDriveLink =
                                  PerspectiveIndex >= 0
                                    ? "https://drive.google.com/file/d/" +
                                      files[PerspectiveIndex]["gd_file_id"] +
                                      "/view"
                                    : "";
                                const ASPIndex = files.findIndex(
                                  (item) =>
                                    item["project_map_field_id"] ===
                                    "BSlQmkony0t3PkqRPiOv"
                                );
                                let ASPDriveLink =
                                  ASPIndex >= 0
                                    ? "https://drive.google.com/file/d/" +
                                      files[ASPIndex]["gd_file_id"] +
                                      "/view"
                                    : "";

                                subject = `(Declined) Ref #: ${project_data.accounting_ref} - ${project_data.contact_first_name} ${project_data.contact_last_name} - ${project_data.name} - Step ${step_number}`;
                                html = `Declined by: ${contactFirstName} ${contactLastName}<br/>Comment: ${text}<br/>Step: ${step_number} <br/> Name: ${
                                  project_data.contact_first_name
                                } ${
                                  project_data.contact_last_name
                                } <br/> Designer:  ${
                                  designer.payload.data()["first_name"]
                                } ${
                                  designer.payload.data()["last_name"]
                                } <br/>Reference #: ${
                                  project_data.accounting_ref
                                }<br/>Installation Plans: ${IPDriveLink}<br/>Order Confirmation: ${OCDriveLink}<br/>Perspectives: ${PDriveLink}<br/>Appliances Spec Sheet: ${ASPDriveLink}<br/>Project:${
                                  baseUrlObj[0]["base_url"]
                                }project/${project_id} <br/>Account: ${
                                  baseUrlObj[0]["base_url"]
                                }contact/${
                                  project_data.contact_id
                                }<br/><br/>-<br/>Automated email sent via RS `;
                              } else {
                                // If Step number is not 5,6
                                subject = `(Declined) Ref #: ${project_data.accounting_ref} - ${project_data.contact_first_name} ${project_data.contact_last_name} - ${project_data.name} - Step ${step_number}`;
                                html = `Declined by: ${contactFirstName} ${contactLastName}<br/>Comment: ${text}<br/>Step: ${step_number} <br/> Name: ${
                                  project_data.contact_first_name
                                } ${
                                  project_data.contact_last_name
                                } <br/> Designer:  ${
                                  designer.payload.data()["first_name"]
                                } ${
                                  designer.payload.data()["last_name"]
                                } <br/>Reference #: ${
                                  project_data.accounting_ref
                                }<br/>Project:${
                                  baseUrlObj[0]["base_url"]
                                }project/${project_id} <br/>Account: ${
                                  baseUrlObj[0]["base_url"]
                                }contact/${
                                  project_data.contact_id
                                }<br/><br/>-<br/>Automated email sent via RS `;
                              }

                              const mailBody = {
                                to: "rs@leichtnewyork.com",
                                subject: subject,
                                body: html,
                                cc: cc,
                              };
                              this._project.initEmail(mailBody).subscribe(
                                (res) => {
                                  if (res) {
                                    this._common.showLoader(false);
                                    this._toastr.success(res.message, "", {
                                      timeOut: 4000,
                                    });
                                  }
                                },
                                (err) => {
                                  this._common.showLoader(false);
                                  this._toastr.error(
                                    `${
                                      err && err.error && err.error.message
                                        ? err.error.message
                                        : "Something went wrong!"
                                    }`,
                                    "",
                                    {timeOut: 4000}
                                  );
                                }
                              );
                            },
                            (err) => {
                              this._common.showLoader(false);
                              this._toastr.error(
                                `${
                                  err && err.error && err.error.message
                                    ? err.error.message
                                    : "Something went wrong!"
                                }`,
                                "",
                                {timeOut: 4000}
                              );
                            }
                          );
                      } else {
                        this._common.showLoader(false);
                        this._toastr.error(
                          `Email configuration not found!`,
                          "",
                          {timeOut: 4000}
                        );
                      }
                    },
                    (err) => {
                      this._common.showLoader(false);
                      this._toastr.error(
                        `${
                          err && err.error && err.error.message
                            ? err.error.message
                            : "Something went wrong!"
                        }`,
                        "",
                        {timeOut: 4000}
                      );
                    }
                  );
              }
            },
            (err) => {
              this._toastr.error(
                `Something went wrong while updating projects!`,
                "",
                {timeOut: 4000}
              );
            }
          );
      },
      (err) => {
        this._toastr.error(
          `Something went wrong while updating projects!`,
          "",
          {timeOut: 4000}
        );
      }
    );
  }

  checkStepVisibility(number, project) {
    this.step7ScratchCondition = false;
    switch (number) {
      case 2:
        return project.estimate_added == "Yes" &&
          project.step1_design_added == "Yes" &&
          project.step1_kps_added == "Yes" &&
          (project.retainer_agreement_added == "Yes" ||
            project.purchase_agreement_cabinetry_added === "Yes")
          ? true
          : false;
      case 3:
        // return project.step2_review_request_state === 'Approved' ? true : false;
        return project.floor_plan_added == "Yes" &&
          project.desired_production_week_added == "Yes"
          ? true
          : false;
      case 5:
        return project.step4_review_request_state === "Approved" ? true : false;
      case 6:
        return project.step5_review_request_state === "Approved" ? true : false;
      case 7:
        if (
          project.step5_review_request_state === "Approved" &&
          project.step6_review_request_state === "Approved" &&
          project.mechanical_plan_added === "Yes" &&
          project.sent_to_production === "Yes" &&
          project.installation_plans_approved === "Yes" &&
          project.order_confirmation_approved === "Yes" &&
          project.perspectives_approved === "Yes" &&
          project.appliance_spec_package_approved === "Yes"
        ) {
          /*
          this.step7ScratchCondition = true;
          const step2ChildError = this.childProjects.filter(item => item.floor_plan_added!= "Yes" || item.design_added!="Yes" || item.desired_production_week_added!="Yes" );
          const step3ChildError = this.childProjects.filter(item => item.step3_review_request_state!= "Approved");
          const step5ChildError = this.childProjects.filter(item => item.step5_review_request_state!= "Approved");
          const step6ChildError = this.childProjects.filter(item => item.step6_review_request_state!= "Approved");
          
          if(step2ChildError.length >0 || step3ChildError.length > 0 || step5ChildError.length > 0 || step6ChildError.length>0){
            if(step2ChildError.length>0){
              this.step7ExistingError = "Since this project was copied from an existing project, all fields in <strong>Step 2</strong> must be added for all copied projects."
            }
            else if(step3ChildError.length > 0) {
              this.step7ExistingError = "Since this project was copied from an existing project, <strong>Step 3</strong> must be approved for all copied projects.";
            }
            else if(step5ChildError.length > 0) {
              this.step7ExistingError = "Since this project was copied from an existing project, <strong>Step 5</strong> must be approved for all copied projects.";
            } else {
              this.step7ExistingError = "Since this project was copied from an existing project, <strong>Step 6</strong> must be approved for all copied projects.";
            }
            return false;
          }else {
            return true;
          } 
          */
          return true;
        } else {
          return false;
        }
      case 7.5:
        return project.delivery_requested === "Yes" ? true : false;
      case 10:
        return project.step9_review_request_state === "Approved" ? true : false;

      default:
        return true;
    }
  }

  openFileListDialog(field_id, project_id) {
    this.dialog.open(ProjectMapFilesDialogComponent, {
      width: "auto",
      data: {
        field_id: field_id,
        project_id: project_id,
      },
    });
  }
  // Step 6 request approval button
  requestApprovalBtn(project_data, emailRecepientId, fieldName) {
    this._common.showLoader(true);
    // Fetch Email Recipient
    this.subscription16 = this._project
      .getEmailRecipient(emailRecepientId)
      .subscribe(
        (emailRes) => {
          const emails = emailRes.docs.map((doc) => doc.data());

          if (emails.length > 0) {
            //Fetch Designer Email
            this.subscription11 = this._lead
              .getContactDetail(project_data.payload.data().owner_contact_id)
              .subscribe(
                (designer) => {
                  const designerEmail = designer.payload.data()["email"]
                    ? designer.payload.data()["email"]
                    : "";

                  this.subscription17 = this._project.getSystemMode().subscribe(
                    (system) => {
                      this._common.showLoader(false);

                      const systemData = system.map((item) =>
                        item.payload.doc.data()
                      );
                      const mode: any = systemData.filter((item) =>
                        item.hasOwnProperty("mode")
                      );
                      const baseUrlObj = systemData.filter((item) =>
                        item.hasOwnProperty("base_url")
                      );
                      let cc =
                        mode[0].mode === "Live"
                          ? emails[0]["live_receipients"] + "," + designerEmail
                          : emails[0]["dev_receipients"] +
                            "," +
                            emails[0]["dev_designers"];
                      if (cc) {
                        if (this.technicalDesignerEmail) {
                          cc = cc + "," + this.technicalDesignerEmail;
                        }
                      } else {
                        if (this.technicalDesignerEmail) {
                          cc = this.technicalDesignerEmail;
                        }
                      }
                      const arr2: any = systemData.filter((item) =>
                        item.hasOwnProperty("email_system_wide")
                      );
                      if (
                        baseUrlObj[0]["base_url"] !== "" &&
                        arr2[0].email_system_wide === "Enabled"
                      ) {
                        const files = this.fileList.map((item) =>
                          item.payload.doc.data()
                        );
                        const IPIndex = files.findIndex(
                          (item) =>
                            item["project_map_field_id"] ===
                            "dTuXL5JW8iSrZCGdDQXJ"
                        );
                        let IPDriveLink =
                          IPIndex >= 0
                            ? "https://drive.google.com/file/d/" +
                              files[IPIndex]["gd_file_id"] +
                              "/view"
                            : "";
                        const OCIndex = files.findIndex(
                          (item) =>
                            item["project_map_field_id"] ===
                            "keJkG4i9ZRGhc23pgIiy"
                        );
                        let OCDriveLink =
                          OCIndex >= 0
                            ? "https://drive.google.com/drive/folders/" +
                              files[OCIndex]["gd_folder_id"]
                            : "";
                        const PerspectiveIndex = files.findIndex(
                          (item) =>
                            item["project_map_field_id"] ===
                            "tgcqF7VCNZPTwRmlvzdW"
                        );
                        let PDriveLink =
                          PerspectiveIndex >= 0
                            ? "https://drive.google.com/file/d/" +
                              files[PerspectiveIndex]["gd_file_id"] +
                              "/view"
                            : "";
                        const ASPIndex = files.findIndex(
                          (item) =>
                            item["project_map_field_id"] ===
                            "BSlQmkony0t3PkqRPiOv"
                        );
                        let ASPDriveLink =
                          ASPIndex >= 0
                            ? "https://drive.google.com/file/d/" +
                              files[ASPIndex]["gd_file_id"] +
                              "/view"
                            : "";

                        //Code to send email
                        const mailBody = {
                          to: "rs@leichtnewyork.com",
                          subject: `Ref #: ${
                            project_data.payload.data().accounting_ref
                          } - ${
                            project_data.payload.data().contact_first_name
                          } ${
                            project_data.payload.data().contact_last_name
                          } - ${
                            project_data.payload.data().name
                          } - Step 6 - ${fieldName} - Approval Request`,
                          body: `Review requested for: ${fieldName}<br/>Step: 6<br/> Name: ${
                            project_data.payload.data().contact_first_name
                          } ${
                            project_data.payload.data().contact_last_name
                          } <br/> Designer:  ${
                            project_data.payload.data().owner_first_name
                          } ${
                            project_data.payload.data().owner_last_name
                          } <br/>Reference #: ${
                            project_data.payload.data().accounting_ref
                          }<br/>Installation Plans: ${IPDriveLink}<br/>Order Confirmation:  ${OCDriveLink}<br/>Perspectives: ${PDriveLink}<br/>Appliances Spec Sheet: ${ASPDriveLink}<br/>Account: ${
                            baseUrlObj[0]["base_url"]
                          }contact/${
                            project_data.payload.data().contact_id
                          }<br/>Project: ${baseUrlObj[0]["base_url"]}project/${
                            project_data.payload.data().id
                          } <br/><br/>-<br/>Automated email sent via RS `,
                          cc: cc,
                        };

                        this._project.initEmail(mailBody).subscribe(
                          (res) => {
                            if (res) {
                              this._common.showLoader(false);
                              this._toastr.success(res.message, "", {
                                timeOut: 4000,
                              });
                            }
                          },
                          (err) => {
                            this._common.showLoader(false);
                            this._toastr.error(
                              `${
                                err && err.error && err.error.message
                                  ? err.error.message
                                  : "Something went wrong!"
                              }`,
                              "",
                              {timeOut: 4000}
                            );
                          }
                        );
                      }
                    },
                    (err) => {
                      this._common.showLoader(false);
                      this._toastr.success(
                        `File uploaded successfully, Mail not sent`,
                        "",
                        {timeOut: 4000}
                      );
                    }
                  );
                },
                (err) => {
                  this._common.showLoader(false);
                  this._toastr.error(
                    `Error while fetching designer email`,
                    "",
                    {timeOut: 4000}
                  );
                }
              );
          } else {
            this._common.showLoader(false);
            this._toastr.success(`Email configuration not found!`, "", {
              timeOut: 4000,
            });
          }
        },
        (err) => {
          this._common.showLoader(false);
          this._toastr.success(
            `File uploaded successfully, Mail not sent`,
            "",
            {timeOut: 4000}
          );
        }
      );
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
    if (this.subscription2) this.subscription2.unsubscribe();
    if (this.subscription3) this.subscription3.unsubscribe();
    if (this.subscription4) this.subscription4.unsubscribe();
    if (this.subscription5) this.subscription5.unsubscribe();
    if (this.subscription6) this.subscription6.unsubscribe();
    if (this.subscription7) this.subscription7.unsubscribe();
    if (this.subscription8) this.subscription8.unsubscribe();
    if (this.subscription9) this.subscription9.unsubscribe();
    if (this.subscription10) this.subscription10.unsubscribe();
    if (this.subscription11) this.subscription11.unsubscribe();
    if (this.subscription12) this.subscription12.unsubscribe();
    // if(this.subscription13) this.subscription13.unsubscribe();
    // if(this.subscription14) this.subscription14.unsubscribe();
    if (this.subscription15) this.subscription15.unsubscribe();
    if (this.subscription16) this.subscription16.unsubscribe();
    if (this.subscription17) this.subscription17.unsubscribe();
    if (this.subscription18) this.subscription18.unsubscribe();
    if (this.subscription19) this.subscription18.unsubscribe();
  }
}
